/** Theme setting: Protect My Order product — excluded from drawer, count bubble, and progress thresholds (checkout total unchanged). */
function getProtectionCartAdjustments(cartData) {
  const pid = window.protectionProductId;
  if (pid == null || pid === '' || !cartData || !Array.isArray(cartData.items)) {
    return { protectionQty: 0, protectionCents: 0 };
  }
  let protectionQty = 0;
  let protectionCents = 0;
  cartData.items.forEach((item) => {
    if (item.product_id == null) return;
    if (String(item.product_id) !== String(pid)) return;
    protectionQty += item.quantity || 0;
    const lineAmt =
      item.final_line_price != null ? item.final_line_price : item.line_price != null ? item.line_price : 0;
    protectionCents += lineAmt;
  });
  return { protectionQty, protectionCents };
}

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.mulVariantOptions = ['Color', 'Select Your Set'];
    this.cartIconButton = document.getElementById('cart-icon-bubble');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.body = document.querySelector('body');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.swiperCartClaim = null;
    this.slideElementsMap = new Map();
    this.cartGiftSelections = []; // FIFO order tracking for cart gift selections
    /** InsCoder WANG.J 2026-05-28 B + Async cart form lazy load state **/
    this.cartFormLoaded = Boolean(this.querySelector('.cart-form'));
    this.cartFormReadyPromise = null;
    /** InsCoder WANG.J 2026-05-28 E + Async cart form lazy load state **/
    this.customerGroupSyncPromise = null;
    this.customerGroupTermCollisionWarning = '';

    // Cart Progress bar (Shipping & Gifts)
    this.cartConfig = JSON.parse(this.querySelector('[data-section-settings]').getAttribute('data-section-settings'));
    this.cartConfigThreshold = this.cartConfig.threshold;
    this.cartLargestThreshold = 0;
    for (const [key, value] of Object.entries(this.cartConfigThreshold)) {
      if(this.cartLargestThreshold < value)
        this.cartLargestThreshold = value;
    }

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('[data-close-cart-drawer]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );


    this.cartIconButton.addEventListener('click', this.open.bind(this))

    // add event on quantity
    if(document.querySelectorAll('.cart-notification__body .quantity__input').length) {
      this.quantityInput();
    }






    this.initRecommendations();

    this.initializeRemoveListeners();

    this.initCartGift();

    window.addEventListener('resize', () => {
      this.setScreenHeight();
    });

    this.preloadCartFormAfterRender();
  }

  connectedCallback() {
    this.bootstrapCustomerGroupTerm();
  }

  async bootstrapCustomerGroupTerm() {
    try {
      if (!this.isUtmTermGroupFeatureEnabled()) {
        await this.syncCustomerGroupTerm();
        return;
      }

      this.getCustomerGroupTerm();
      await this.syncCustomerGroupTerm();
    } catch (error) {
      console.error('Error bootstrapping customer group term:', error);
    }
  }

  /** InsCoder WANG.J 2026-05-28 B + Async cart form lazy load **/
  preloadCartFormAfterRender() {
    if (this.cartFormLoaded) {
      return;
    }

    window.setTimeout(() => {
      this.ensureCartFormLoaded();
    }, 0);
  }

  async initializeLazyCartFormContent() {
    this.initRecommendations();
    if (document.querySelectorAll('.cart-notification__body .quantity__input').length) {
      this.quantityInput();
    }

    this.initializeRemoveListeners();
    this.initCartGift();
    this.initializeGroupBClaimButtons();

    this.notification.querySelectorAll('variant-radios').forEach((variantRadio) => {
      if (typeof variantRadio.initializeVariantPicker === 'function') {
        variantRadio.initializeVariantPicker();
      }
    });

    if (typeof window.initializeCartNotificationCurrencyState === 'function') {
      window.initializeCartNotificationCurrencyState();
    }

    if (this.notification.querySelector('.cart-claim__wrapper')) {
      this.initializeClaimVariants();
      if (this.swiperCartClaim) {
        await this.validateSlides();
      }
    }
  }

  async ensureCartFormLoaded() {
    const existingCartForm = this.querySelector('.cart-form');
    if (existingCartForm) {
      this.cartFormLoaded = true;
      return true;
    }

    if (this.cartFormReadyPromise) {
      return this.cartFormReadyPromise;
    }

    const requestConfigNode = this.querySelector('.cart-notification-form-data');
    const formContainer = this.querySelector('[data-cart-form-container]');

    if (!requestConfigNode || !formContainer) {
      console.error('Cart form lazy load prerequisites missing.');
      return false;
    }

    this.cartFormReadyPromise = (async () => {
      try {
        const requestConfig = JSON.parse(requestConfigNode.textContent);
        if (!requestConfig.sectionUrl) {
          console.error('Cart form lazy load sectionUrl is missing.');
          return false;
        }

        const response = await fetch(requestConfig.sectionUrl, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          console.error('Cart form lazy request failed.', {
            url: requestConfig.sectionUrl,
            status: response.status
          });
          return false;
        }

        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const lazyCartForm = html.querySelector('.cart-form');

        if (!lazyCartForm) {
          console.error('Cart form lazy response is missing expected .cart-form selector.', {
            url: requestConfig.sectionUrl,
            responsePreview: responseText.slice(0, 400)
          });
          return false;
        }

        formContainer.innerHTML = lazyCartForm.outerHTML;
        this.cartFormLoaded = true;
        await this.initializeLazyCartFormContent();

        return true;
      } catch (error) {
        console.error('Cart form lazy load failed.', error);
        return false;
      } finally {
        this.cartFormReadyPromise = null;
      }
    })();

    return this.cartFormReadyPromise;
  }
  /** InsCoder WANG.J 2026-05-28 E + Async cart form lazy load **/



  initRecommendations(){
    // Helper function to format monetary amounts consistently
    const formatAmount = formatMoneyWithoutTrailingZeros;


    var allNostoElements = document.querySelectorAll(".nosto_element.nosto_element__sidebar .cart__item");

    var cartObj = this;
    allNostoElements.forEach(async function(nostoElementItem) {
      var button = nostoElementItem;
      // Log the data-variant-id attribute
      var productHandle = button.getAttribute('data-handle');
      var productId = button.getAttribute('data-product-id');
      var variantId = button.getAttribute('data-variant-id');
      // Fetch product data from preloaded data
      var product;
      var result = await fetch(`${window.routes.root_url}/products/${productHandle}?view=jsonview`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      if(result.status === 200) {
        product = await result.json();
      }
      // var product = window.preloadedProducts[productId];
      const cartNotification = document.querySelector("cart-notification");
      // && cartNotification.mulVariantOptions.includes(product.options[0])
      if (product && product.id && product.variants.length > 1) {
        let item = product.variants[0];
        const variants = product.variants;
        variants.map((variant, variantIndex) => {
          if(variant.available && item == product.variants[0]){
            item = variant;
          }
        });
        var variantPickerHTML = `
        <div class="cart-item__variant-picker">
          <div class="variant-picker__content">
            <div class="cart-notification__header">
              <h2 class="cart-notification__heading caption-large text-body">Select Shade</h2>
              <button type="button" class="variant-picker__close link link--text focus-inset">
                <img src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/close.svg?v=1725933626" width="24" height="24">
              </button>
            </div>
            <div class="cart-item" data-variant-id="${item.id}">
              <div class="cart-item__media">
                <img class="cart-item__image"
                  src="${ product.featured_image.src }"
                  loading="lazy"
                  width="240"
                  height="240"
                >
              </div>
              <div class="cart-item__right">
                <div class="cart-item__details">
                  <a href="${product.url}" class="cart-item__name h4 break">
                    ${product.title}
                    <p class="cart-item__property">${item.title.split("__")[0]}</p>
                  </a>
                  ${item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${item.selling_plan_allocation.selling_plan.name}</p>` : ''}
                  <div class="cart-item__quantity">
                      <div class="cart-item__quantity-wrapper">
                        <quantity-input class="quantity">
                          <button class="quantity__button no-js-hidden" name="minus" type="button">
                            <span class="visually-hidden">decrease ${product.title}</span>
                            <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
                              <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                            </svg>
                          </button>
                          <input class="quantity__input" type="number" name="updates[]" variant-id="${product.id}" value="1" min="0" aria-label="${product.title}" id="Quantity-${item.id}" data-index="${item.id}">
                          <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">increase ${product.title}</span>
                            <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
                              <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                <path d="M8,1 L8,15"></path>
                                <path d="M1,8 L15,8"></path>
                              </g>
                            </svg>
                          </button>
                        </quantity-input>
                      </div>
                    </div>

                  </div>
              </div>

              <div class="cart-item__options">
                <div class="cart-item__price">
                  <span class="cart-item__price-compare">${formatAmount(product.price)}</span>
                </div>
              </div>
            </div>
            <variant-radios class="no-js-hidden swatch_round" data-section data-url="/products/${productHandle}">
              <div class="cart-item__active-variant">
                <div class="active-variant__content">
                  ${(() => {
                    const firstVariant = item; // Access the first variant directly
                    const swatchColor = firstVariant.metafields.swatch_color || 'transparent';
                    const variantTitle = firstVariant.name || 'Unknown Variant';

                    const swatchFile = firstVariant ? firstVariant.metafields.swatch_img: '';
                    if(swatchFile && (!swatchColor || swatchColor == 'transparent')){
                       return `
                        <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;">
                          <img src="${ swatchFile }" loading="lazy" width="58" height="58">
                        </span>
                        <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                      `;
                    }
                    return `
                      <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;"></span>
                      <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                    `;
                  })()}
                </div>
                <img class="active-variant__close inverted" src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/arrow-down.svg?v=1725933654" height="24" width="24">
              </div>
              <div class="active-variant__drawer">

              </div>

              <script type="application/json">
                ${JSON.stringify(variants)}
              </script>
            </variant-radios>
            <div class="cart-notification__footer footer__static">
              <div class="cart_drawer_formBox">
                ${(() => {
                  const firstVariant = item; // Access the first variant directly
                  return `
                    <button type="button" class="button btn variant-update__btn variant-update__nosto" data-variant-id="${firstVariant.id}" data-quantity="${ item.quantity }">
                      <span class="btn__text button--full-width">Add To Cart</span>
                      <span id="button__price" class="button__price nosto-price">${formatAmount(firstVariant.price)}</span>
                    </button>
                  `;
                })()}
              </div>
            </div>
          </div>
        </div>
      `;

      // Append the variant picker into the .cart-item__variant-preloaded div
      var variantPickerContainer = document.querySelector('.cart-item__variant-preloaded');
      if (variantPickerContainer) {
        // Add a unique identifier to the variant picker HTML
        var uniqueId = 'variant-picker-' + productId;
        variantPickerHTML = variantPickerHTML.replace('<div class="cart-item__variant-picker">', `<div class="cart-item__variant-picker" data-variant-picker-id="${uniqueId}" data-product-handle="${productHandle }">`);
        variantPickerContainer.insertAdjacentHTML('beforeend', variantPickerHTML);

        // Store a reference to the newly inserted variant picker using the unique identifier
        var variantPicker = variantPickerContainer.querySelector(`[data-variant-picker-id="${uniqueId}"]`);

        // Find the closest .cart__item or .cart__item-upsell element
        var closestCartItem = button.closest('.cart__item, .cart__item-upsell');
        // Add a new click listener to open the variant picker
        closestCartItem.addEventListener('click', async function(event) {
          event.preventDefault();

          // Close all other variant pickers
          var allVariantPickers = document.querySelectorAll('.variant-picker__expanded');
          allVariantPickers.forEach(function(picker) {
            if(picker.classList.contains('one-time')){
              picker.remove();
            }else{
              picker.classList.remove('variant-picker__expanded');
              picker.querySelector(".active-variant__drawer").innerHTML = ""
            }
          });

          // Logic to open the variant picker
          if (variantPicker) {
            variantPicker.classList.add('variant-picker__expanded');
            // Initialize the variant picker
            let variantRadios = variantPicker.querySelector('variant-radios');
            variantRadios.updateCartNotification();
          }
        });

        if (variantPicker) {
          // Add close button listener
          const closeButton = variantPicker.querySelector('.variant-picker__close');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              // Handle close button logic here
              if(variantPicker.classList.contains('one-time')){
                variantPicker.remove();
              }else{
                variantPicker.classList.remove('variant-picker__expanded');
                variantPicker.querySelector(".active-variant__drawer").innerHTML = ""
                // Reset footer z-index to 999 when variant picker closes, overriding !important
                document.querySelector('.cart-notification__footer.footer__main').style.setProperty('z-index', '999', 'important');
              }
            });
          }
        }
      }

      } else if(variantId){
         var closestCartItem = button.closest('.cart__item, .cart__item-upsell');
        // Add a new click listener to open the variant picker
        closestCartItem.addEventListener('click', async function(event) {
          event.preventDefault();
          // addVariant
          fetch('/cart/add.js', {
              body: JSON.stringify({ id: variantId, quantity: 1 }),
              credentials: "same-origin",
              method: "POST",
              headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          })
          .then((response) => response.json())
          .then((response) => {
            cartObj.renderContents();
          });
        })

      }

    });
  }

  /** InsCoder WANG.J 2026-05-28 B + Open drawer without triggering cart form fetch **/
  async open(cartData = null) {
    const customerGroupTerm = this.getCustomerGroupTerm();
    console.log('Find customer group term:', customerGroupTerm);

    const cartFormReady = await this.ensureCartFormLoaded();
    if (!cartFormReady && !this.querySelector('.cart-form')) {
      return;
    }

    try {
      if (!cartData || !Array.isArray(cartData.items)) {
        cartData = await window.runCartSync();
      }
      await this.syncCustomerGroupTerm(cartData);
      if (cartData) {
        let progressContext = this.buildProgressContext(cartData);
        const groupConfig = this.getNewCustomerGroupConfig(progressContext.exchangeRate);
        progressContext.customerGroupConfig = groupConfig;
        if (await this.reconcileGroupBClaim(progressContext, groupConfig)) {
          await this.renderContents('', true);
          cartData = await window.getCart();
          progressContext = this.buildProgressContext(cartData);
          progressContext.customerGroupConfig = groupConfig;
        }
        this.updateProgressBarDisplay(progressContext, groupConfig);
      }
    } catch (error) {
      console.error('Error updating cart drawer progress on open:', error);
    }
    const pageOverlay = document.querySelector('.cart-notification__overlay');

    this.setScreenHeight(); // ios fix
    if (this.header) this.header.reveal();

    this.body.classList.add('no-scroll');
    if (pageOverlay) {
      pageOverlay.classList.add('active');
    }
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    const cartBody = this.notification.querySelector('.cart-notification__body');
    cartBody.style.overflow = 'scroll';
    cartBody.style.position = 'static';

    if (window.innerWidth > 989) {
      let nostoElement = document.querySelector('.nosto_element__dropdown');
      const cartFooter = this.notification.querySelector('.cart-notification__footer.footer__main')
      if (cartFooter) {
        cartFooter.classList.add('animate');
      }

      setTimeout(() => {
        if (nostoElement) {
          nostoElement.classList.add('nosto_element--expanded');
        }
      }, 350);
    }

    document.body.addEventListener('click', this.onBodyClick);
  }
  /** InsCoder WANG.J 2026-05-28 E + Await async cart form before open **/

  close() {
    const pageOverlay = document.querySelector('.cart-notification__overlay');
    if (window.innerWidth > 989) {
      let nostoElement = document.querySelector('.nosto_element__dropdown');
      nostoElement.classList.remove('nosto_element--expanded');
    }

    setTimeout(() => {
      pageOverlay.classList.remove('active');
      this.body.classList.remove('no-scroll');
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus(this.activeElement);
      const cartFooter = this.notification.querySelector('.cart-notification__footer.footer__main');
      cartFooter.classList.remove('animate');
    }, 100);

    setTimeout(() => {
      const cartBody = this.notification.querySelector('.cart-notification__body');
      cartBody.style.overflowY = 'hidden';
      cartBody.style.position = 'relative';
      const cartItems = document.querySelectorAll('#cart-items .cart-item');
    }, 500);

  }

  async validateGWPProducts(cartData) {
    const snapshot = cartData || await window.getCart();
    if (!snapshot) return;

    // If there are GWP items and no non-GWP items, remove the GWP items
    const plan = window.computeGwpClearMutations
      ? window.computeGwpClearMutations(snapshot)
      : { add: [], remove: {} };

    if (Object.keys(plan.remove || {}).length > 0) {
      try {
        await window.removeGiftProduct(plan.remove);
        // Validate slides after removing GWP products
      } catch (error) {
        console.error('Failed to remove GWP products:', error);
      }
    }
  }

  async validateSlides() {
    const cartData = await window.getCart();
    const cartItems = cartData.items.map(item => item.id.toString());
    const processedVariants = new Set(); // Set to keep track of processed variant IDs
    const slidesToRemove = [];
    const claimLimit = window.claimLimit; // Get the claim limit from the global variable

    // Reinsert slides back into the slider from slideElementsMap
    this.slideElementsMap.forEach((value, key) => {
      const slideElement = document.createElement('div');
      slideElement.classList.add('swiper-slide');
      slideElement.innerHTML = value.html;
      this.swiperCartClaim.appendSlide(slideElement);
    });

    console.log(this.slideElementsMap, 'this.slideElementsMap');

    // Clear the slideElementsMap after reinserting the slides
    // this.slideElementsMap.clear();

    // Reinitialize the Swiper instance
    this.swiperCartClaim.update();
    this.swiperCartClaim.loopCreate();

    // Iterate over the actual slider elements on the page
    Array.from(this.swiperCartClaim.slides).forEach(slide => {
      const productDataElement = slide.querySelector('.cart-item__media img');
      if (productDataElement) {
        const dataProduct = productDataElement.getAttribute('data-product');
        try {
          const productData = JSON.parse(dataProduct);
          const variantId = productData.variants[0].id;

          if (cartItems.includes(variantId.toString())) {
            const ariaLabel = slide.getAttribute('aria-label');
            const slidePosition = parseInt(ariaLabel.split('/')[0], 10) - 1;

            // Check if the variant ID has already been processed
            if (!processedVariants.has(variantId) && !slide.classList.contains('swiper-slide-duplicate')) {
              // Save the active and non-duplicate slide element and its index in the Map before removing it
              this.slideElementsMap.set(variantId, { html: slide.outerHTML, index: slidePosition });

              // Mark the variant ID as processed
              processedVariants.add(variantId);

              // Add the slide position to the list of slides to remove
              slidesToRemove.push(slidePosition);
            }
          }
        } catch (error) {
          console.error('Error parsing product data:', error);
        }
      }
    });

    // Destroy the loop, remove all slides, and then create and update the loop
    if (slidesToRemove.length > 0) {
      this.swiperCartClaim.loopDestroy();

      // Sort slide positions in descending order to avoid index shifting issues
      slidesToRemove.sort((a, b) => b - a);

      slidesToRemove.forEach(slidePosition => {
        this.swiperCartClaim.removeSlide(slidePosition);
      });

      // Update Swiper to reflect the removed slides
      this.swiperCartClaim.update();

      // Check the number of remaining unique slides
      const uniqueSlides = Array.from(this.swiperCartClaim.slides).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

      if (uniqueSlides.length > 1) {
        this.swiperCartClaim.loopCreate();
        this.swiperCartClaim.update();

        // Show navigation arrows
        document.querySelector('.swiper-button-next').style.display = 'block';
        document.querySelector('.swiper-button-prev').style.display = 'block';
      } else {
        // Remove all duplicate slides if there is only one unique slide
        const duplicateSlides = Array.from(this.swiperCartClaim.slides).filter(slide => slide.classList.contains('swiper-slide-duplicate'));
        duplicateSlides.forEach(duplicateSlide => duplicateSlide.remove());

        // Update Swiper to reflect the removal of duplicate slides
        this.swiperCartClaim.update();

        // Hide navigation arrows
        document.querySelector('.swiper-button-next').style.display = 'none';
        document.querySelector('.swiper-button-prev').style.display = 'none';
      }
    }

    // Check if the claimed count exceeds or equals the claim limit
    const claimedCount = this.slideElementsMap.size;

    const cartClaimWrapper = document.querySelector('.cart-claim__wrapper');

     var freeShipping = window.freeShipping.shipping[0],
         freeClaimPrice = (freeShipping.freeClaimThreshold * 100);

    const exchangeRate = parseFloat(window.Shopify.currency.rate);

    const freeClaimPriceLocal = (freeClaimPrice / 100) *  exchangeRate * 100;
    const claimCartTotal =
      cartData.total_price - getProtectionCartAdjustments(cartData).protectionCents;
    if (claimCartTotal > freeClaimPriceLocal && cartClaimWrapper) {
      if (claimedCount >= claimLimit) {
        cartClaimWrapper.classList.add('hidden');
      } else {
        cartClaimWrapper.classList.remove('hidden');
        // Reinitialize the slider if it was hidden and is now shown
        if (cartClaimWrapper.classList.contains('hidden')) {
          this.initializeClaimVariants();
        }
      }
    }else{
      cartClaimWrapper.classList.add('hidden');
      this.slideElementsMap.forEach(async (value, key) => {
        document.querySelector(".cart-item[data-variant-id='"+key+"'] .CartItem__Remove").click()
      });
    }
  }

initializeClaimVariants() {
  const claimSlider = this.notification.querySelector('.swiper-cart-claim');
  if (!claimSlider || typeof Swiper === 'undefined') {
    return;
  }

  // Destroy the existing Swiper instance if it exists
  if (this.swiperCartClaim) {
    this.swiperCartClaim.destroy(true, true);
    this.swiperCartClaim = null;
  }

  this.swiperCartClaim = new Swiper(claimSlider, {
    loop: true,
    slidesPerView: 1.25,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    noSwipingSelector: '.cart-claim__button',
    pagination: {
      el: claimSlider.querySelector('.swiper-pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: claimSlider.querySelector('.swiper-button-next'),
      prevEl: claimSlider.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      1200: {
        slidesPerView: 1.25,
        spaceBetween: 20,
        slidesOffsetBefore: 20,
      },
    },
  });

  // Add event listeners to the claim buttons
  document.querySelectorAll('.cart-claim__button').forEach(button => {
    // Remove existing event listeners if they exist
    if (button.dataset.listenerAdded) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      button = newButton;
    }

    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const slideElement = button.closest('.swiper-slide');
      const slideIndex = this.swiperCartClaim.slides.indexOf(slideElement);


      const productId = button.getAttribute('data-product-id');
      const productDataElement = document.querySelector(`.swiper-slide[data-product-id="${productId}"] .cart-item__media img`);
      let productData;

      // Log the data-product attribute to inspect its value
      const dataProduct = productDataElement.getAttribute('data-product');

      try {
        productData = JSON.parse(dataProduct);
      } catch (error) {
        console.error('Error parsing product data:', error);
        return;
      }

      const variantId = productData.variants.length > 1 ? null : productData.variants[0].id;

      if (variantId) {
        document.querySelector('.mini-cart-overlay').style.opacity = "1";
        document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";
        this.addProductToCart(variantId, slideElement);
      } else {
        this.activateVariantSelector(productId);
      }
    });

    // Mark the button as having a listener added
    button.dataset.listenerAdded = 'true';
  });
}

// ==========================================
// Cart Gift Methods
// ==========================================

initCartGift() {
  const wrapper = document.querySelector('.cart-gift__wrapper');
  if (!wrapper) return;

  const maxGifts = parseInt(wrapper.dataset.maxGifts) || 2;
  const addText = wrapper.dataset.addText || 'Add';
  const addedText = wrapper.dataset.addedText || 'Added';
  const cards = wrapper.querySelectorAll('.cart-gift__card');
  const removeAllBtn = wrapper.querySelector('.cart-gift__remove-all');

  // Sync state from cart — find items with _source: 'cart-gift'
  window.getCart().then(cartData => {
    const giftItems = cartData.items.filter(item => item.properties && item.properties._source === 'cart-gift');
    const giftVariantIds = giftItems.map(item => item.variant_id.toString());

    // Rebuild selections array from cart data, preserving FIFO order
    // Remove any selections not in cart anymore
    this.cartGiftSelections = this.cartGiftSelections.filter(id => giftVariantIds.includes(id.toString()));
    // Add any cart items not yet in selections
    giftVariantIds.forEach(id => {
      if (!this.cartGiftSelections.includes(id) && !this.cartGiftSelections.includes(Number(id))) {
        this.cartGiftSelections.push(id);
      }
    });

    // Update card UI states
    cards.forEach(card => {
      const variantId = card.dataset.variantId;
      const btn = card.querySelector('.cart-gift__card-btn');
      const btnText = btn.querySelector('.cart-gift__card-btn-text');
      const isInCart = giftVariantIds.includes(variantId.toString());

      if (isInCart) {
        btn.classList.add('cart-gift__card-btn--added');
        btnText.textContent = addedText;
      } else {
        btn.classList.remove('cart-gift__card-btn--added');
        btnText.textContent = addText;
      }
    });

    // REMOVE ALL button visibility
    if (this.cartGiftSelections.length >= maxGifts) {
      removeAllBtn.style.display = 'block';
    } else {
      removeAllBtn.style.display = 'none';
    }

    // Bind click events (clone to remove old listeners)
    cards.forEach(card => {
      const btn = card.querySelector('.cart-gift__card-btn');
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = newBtn.dataset.variantId;
        const isAdded = newBtn.classList.contains('cart-gift__card-btn--added');

        if (isAdded) {
          this.handleCartGiftRemove(variantId);
        } else {
          this.handleCartGiftAdd(variantId);
        }
      });
    });

    // REMOVE ALL click
    const newRemoveAllBtn = removeAllBtn.cloneNode(true);
    removeAllBtn.parentNode.replaceChild(newRemoveAllBtn, removeAllBtn);
    newRemoveAllBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleCartGiftRemoveAll();
    });
  });
}

async handleCartGiftAdd(variantId) {
  const wrapper = document.querySelector('.cart-gift__wrapper');
  if (!wrapper) return;

  const maxGifts = parseInt(wrapper.dataset.maxGifts) || 2;

  // Show loading
  const overlay = document.querySelector('.mini-cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'auto';

  try {
    // If at max, remove the oldest selection first (FIFO)
    if (this.cartGiftSelections.length >= maxGifts) {
      const oldestVariantId = this.cartGiftSelections[0];
      // Find the cart item key for this variant
      const cartData = await window.getCart();
      const oldItem = cartData.items.find(item =>
        item.variant_id.toString() === oldestVariantId.toString() &&
        item.properties && item.properties._source === 'cart-gift'
      );
      if (oldItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldItem.key, quantity: 0 }),
        });
        this.cartGiftSelections.shift();
      }
    }

    // Add the new gift
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _source: 'cart-gift' },
      }),
    });

    this.cartGiftSelections.push(variantId.toString());
    this.renderContents();
  } catch (error) {
    console.error('Error adding cart gift:', error);
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
}

initializeGroupBClaimButtons() {
  document.querySelectorAll('[data-group-claim-btn], [data-group-b-claim-btn]').forEach((button) => {
    if (button.dataset.listenerAdded === 'true') return;

    button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const productId = button.getAttribute('data-product-id');
      const variantId = button.getAttribute('data-variant-id');
      const variantsCount = parseInt(button.getAttribute('data-variants-count'), 10);
      const customerGroupKey = button.getAttribute('data-group-key') || 'groupB';
      const discountCode =
        button.getAttribute('data-customer-group-discount-code') ||
        button.getAttribute('data-group-b-discount-code');
      if (!productId) return;

      const hasOnlyOneVariant = !Number.isNaN(variantsCount) && variantsCount <= 1;
      if (hasOnlyOneVariant && variantId) {
        if (button.dataset.loading === 'true') return;
        button.dataset.loading = 'true';
        try {
          await this.claimCustomerGroupGiftSingleVariant(variantId, discountCode, customerGroupKey);
        } finally {
          button.dataset.loading = 'false';
        }
        return;
      }

      const variantPicker =
        document.getElementById(`variant-picker-${customerGroupKey}-${productId}`) ||
        document.getElementById(`variant-picker-group-b-${productId}`);
      if (variantPicker) {
        const variantRadios = variantPicker.querySelector('variant-radios');
        if (variantRadios && typeof variantRadios.updateCartNotification === 'function') {
          variantRadios.updateCartNotification(false, variantId);
        }
        variantPicker.classList.remove('hidden');
        variantPicker.classList.add('variant-picker__expanded');
      }
    });

    button.dataset.listenerAdded = 'true';
  });
}

async claimGroupBGiftSingleVariant(variantId, groupBDiscountCode) {
  return this.claimCustomerGroupGiftSingleVariant(variantId, groupBDiscountCode, 'groupB');
}

async claimCustomerGroupGiftSingleVariant(variantId, discountCode, customerGroupKey = '') {
  const overlay = document.querySelector('.mini-cart-overlay');
  if (overlay) {
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
  }

  let addedItem = null;
  const claimProperties = {
    _source: 'cart-claim'
  };
  if (customerGroupKey === 'groupA' || customerGroupKey === 'groupB') {
    claimProperties._customer_group_key = customerGroupKey;
  }

  try {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: claimProperties
      })
    });

    if (!addResponse.ok) {
      throw new Error(`Failed to add customer group gift to cart: ${addResponse.status}`);
    }

    addedItem = await addResponse.json().catch(() => null);

    if (discountCode) {
      const currentCustomerGroupTerm =
        typeof this.getCustomerGroupTerm === 'function' ? this.getCustomerGroupTerm() : '';

      const discountPayload = currentCustomerGroupTerm
        ? {
            discount: discountCode,
            attributes: {
              utm_term: currentCustomerGroupTerm
            }
          }
        : {
            discount: discountCode
          };

      const discountResponse = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(discountPayload)
      });

      const discountCart = discountResponse.ok
        ? await discountResponse.json().catch(() => null)
        : null;
      const normalizedDiscountCode = discountCode.trim().toLowerCase();
      const discountApplied = Boolean(
        discountCart &&
        Array.isArray(discountCart.cart_level_discount_applications) &&
        discountCart.cart_level_discount_applications.some((application) =>
          [application.title, application.code, application.name].some((value) =>
            typeof value === 'string' && value.trim().toLowerCase() === normalizedDiscountCode
          )
        )
      );

      if (!discountApplied) {
        await this.removeCustomerGroupGiftLine(addedItem?.key);
        throw new Error(`Failed to apply customer group discount code: ${discountResponse.status}`);
      }
    }

    this.renderContents();
  } catch (error) {
    console.error('Error claiming customer group gift:', error);
    try {
      await this.renderContents();
    } catch (renderError) {
      console.error('Error refreshing cart after customer group claim failure:', renderError);
    }
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }
  }
}

async removeCustomerGroupGiftLine(lineItemKey) {
  if (!lineItemKey) return false;

  const response = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
  });

  if (!response.ok) {
    console.error('Failed to remove customer group gift after discount failure:', response.status);
    return false;
  }

  return true;
}

async handleCartGiftRemove(variantId) {
  const overlay = document.querySelector('.mini-cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'auto';

  try {
    const cartData = await window.getCart();
    const giftItem = cartData.items.find(item =>
      item.variant_id.toString() === variantId.toString() &&
      item.properties && item.properties._source === 'cart-gift'
    );

    if (giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });

      this.cartGiftSelections = this.cartGiftSelections.filter(
        id => id.toString() !== variantId.toString()
      );
    }

    this.renderContents();
  } catch (error) {
    console.error('Error removing cart gift:', error);
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
}

async handleCartGiftRemoveAll() {
  const overlay = document.querySelector('.mini-cart-overlay');
  overlay.style.opacity = '1';
  overlay.style.pointerEvents = 'auto';

  try {
    const cartData = await window.getCart();
    const giftItems = cartData.items.filter(item =>
      item.properties && item.properties._source === 'cart-gift'
    );

    // Remove all gift items sequentially
    for (const item of giftItems) {
      await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    }

    this.cartGiftSelections = [];
    this.renderContents();
  } catch (error) {
    console.error('Error removing all cart gifts:', error);
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
}

addProductToCart(variantId, slideElement) {
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        _source: 'cart-claim',
      }
    }),
  })
  .then(response => response.json())
  .then(data => {
    // Save the slide BEFORE destroying the loop
    const slideHtml = slideElement.outerHTML;
    const slideIndex = Array.from(this.swiperCartClaim.slides)
      .filter(slide => !slide.classList.contains('swiper-slide-duplicate'))
      .indexOf(slideElement);

    // Store in map before any swiper modifications
    this.slideElementsMap.set(variantId, {
      html: slideHtml,
      index: slideIndex
    });

    // Now handle the Swiper updates
    this.swiperCartClaim.loopDestroy();
    this.swiperCartClaim.removeSlide(slideIndex);

    const uniqueSlides = Array.from(this.swiperCartClaim.slides)
      .filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

    if (uniqueSlides.length > 1) {
      this.swiperCartClaim.loopCreate();
      this.swiperCartClaim.update();
      document.querySelector('.swiper-button-next').style.display = 'block';
      document.querySelector('.swiper-button-prev').style.display = 'block';
    } else {
      const duplicateSlides = this.swiperCartClaim.wrapperEl.querySelectorAll('.swiper-slide-duplicate');
      duplicateSlides.forEach(slide => slide.remove());
      this.swiperCartClaim.update();
      document.querySelector('.swiper-button-next').style.display = 'none';
      document.querySelector('.swiper-button-prev').style.display = 'none';
    }

    // Call these after the slide is properly stored
    this.renderContents();
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  });
}

  activateVariantSelector(productId) {
    const variantPicker = document.getElementById(`variant-picker-${productId}`);
    if (variantPicker) {
      variantPicker.classList.remove('hidden');
      variantPicker.classList.add('variant-picker__expanded');
    }
  }

  async handleRemoveCartClaim(itemKey, variantId) {
    try {
        const response = await fetch(`/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // Add this to indicate AJAX request
            },
            body: JSON.stringify({
                id: itemKey,
                quantity: 0,
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // Ensure variantId is treated as a number
        const variantIdNum = Number(variantId);

        // Retrieve the slide element and its index from the Map
        let slideData;
        for (let [key, value] of this.slideElementsMap.entries()) {
            if (key === variantIdNum) {
                slideData = value;
                break;
            }
        }

        if (slideData) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = slideData.html;
            const slideElement = tempDiv.firstChild;

            // Check if a slide with the same data-variant-id already exists
            const existingSlide = this.swiperCartClaim.wrapperEl.querySelector(`[data-variant-id="${variantIdNum}"]`);
            if (!existingSlide) {
                // Use the index from the slideData object
                const insertPosition = slideData.index;

                // Get all slides including duplicates
                const allSlides = Array.from(this.swiperCartClaim.slides);

                // Calculate the correct position
                let correctPosition = insertPosition;
                allSlides.forEach((slide, index) => {
                    if (index < insertPosition && slide.classList.contains('swiper-slide-duplicate')) {
                        correctPosition--;
                    }
                });

                // Insert the slide at the correct position
                this.swiperCartClaim.addSlide(correctPosition, slideElement.outerHTML);
                this.swiperCartClaim.update();

                // Filter out duplicate slides
                const uniqueSlides = Array.from(this.swiperCartClaim.slides)
                    .filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

                // Update navigation arrows visibility
                const navigationArrows = document.querySelectorAll('.swiper-button-next, .swiper-button-prev');
                if (uniqueSlides.length === 1) {
                    // Remove duplicate slides
                    const duplicateSlides = this.swiperCartClaim.wrapperEl.querySelectorAll('.swiper-slide-duplicate');
                    duplicateSlides.forEach(slide => slide.remove());
                    this.swiperCartClaim.update();
                    navigationArrows.forEach(arrow => arrow.style.display = 'none');
                } else {
                    this.swiperCartClaim.update();
                    navigationArrows.forEach(arrow => arrow.style.display = 'block');
                }
            }

            // Remove the entry from slideElementsMap
            const deleteSuccess = this.slideElementsMap.delete(variantIdNum);
            console.log('Delete operation successful:', deleteSuccess);
        }

        await this.validateSlides();
    } catch (error) {
        console.error('Error removing cart claim item:', error);
    }
  }

  getCustomerGroupStorageKey() {
    return 'utm_term';
  }

  getConfiguredUtmTerm() {
    return (window.customerGroupSettings?.utmTerm || '').trim();
  }

  getCustomerGroupTermConfig(groupKey) {
    const configuredTerms = window.customerGroupSettings?.groupTerms || {};
    const configuredTerm = configuredTerms[groupKey];
    if (typeof configuredTerm === 'string' && configuredTerm.trim()) {
      return configuredTerm.trim();
    }

    return groupKey === 'groupA' ? 'GroupA' : this.getConfiguredUtmTerm() || 'GroupB';
  }

  isUtmTermGroupFeatureEnabled() {
    return Boolean(window.customerGroupSettings?.enabled);
  }

  persistCustomerGroupTerm(term) {
    try {
      if (term) {
        window.localStorage.setItem(this.getCustomerGroupStorageKey(), term);
      } else {
        window.localStorage.removeItem(this.getCustomerGroupStorageKey());
      }
    } catch (error) {
      console.warn('Failed to persist utm_term to localStorage:', error);
    }
  }

  clearStoredCustomerGroupTerm() {
    try {
      if (window.localStorage.getItem(this.getCustomerGroupStorageKey())) {
        window.localStorage.removeItem(this.getCustomerGroupStorageKey());
      }
    } catch (error) {
      console.warn('Failed to clear utm_term from localStorage:', error);
    }
  }

  normalizeCustomerGroupTerm(term) {
    return typeof term === 'string' ? term.trim() : '';
  }

  getStoredCustomerGroupTerm() {
    try {
      return this.normalizeCustomerGroupTerm(
        window.localStorage.getItem(this.getCustomerGroupStorageKey())
      );
    } catch (error) {
      console.warn('Failed to read utm_term from localStorage:', error);
      return '';
    }
  }

  getCustomerGroupTerm() {
    if (!this.isUtmTermGroupFeatureEnabled()) {
      this.clearStoredCustomerGroupTerm();
      return '';
    }

    const urlTerm = this.normalizeCustomerGroupTerm(
      new URLSearchParams(window.location.search).get('utm_term')
    );

    if (urlTerm) {
      this.persistCustomerGroupTerm(urlTerm);
      return urlTerm;
    }

    return this.getStoredCustomerGroupTerm();
  }

  async syncCustomerGroupTerm(cartData = null) {
    if (this.customerGroupSyncPromise) {
      return this.customerGroupSyncPromise;
    }

    this.customerGroupSyncPromise = this._syncCustomerGroupTerm(cartData).finally(() => {
      this.customerGroupSyncPromise = null;
    });

    return this.customerGroupSyncPromise;
  }

  async _syncCustomerGroupTerm(cartData = null) {
    const currentCartData = cartData || await window.getCart();
    const currentAttributeRaw =
      currentCartData &&
      currentCartData.attributes &&
      currentCartData.attributes.utm_term;
    const currentAttribute = this.normalizeCustomerGroupTerm(currentAttributeRaw);
    const groupTerm = this.getCustomerGroupTerm();

    if (!this.isUtmTermGroupFeatureEnabled()) {
      this.clearStoredCustomerGroupTerm();
      if (currentAttribute) {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            attributes: {
              utm_term: ''
            }
          })
        });
        if (!response.ok) {
          console.error('Failed to update cart attributes:', response.status);
        }

        return window.getCart();
      }

      return currentCartData;
    }

    if (!groupTerm) {
      if (currentAttribute) {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            attributes: {
              utm_term: ''
            }
          })
        });
        if (!response.ok) {
          console.error('Failed to update cart attributes:', response.status);
        }

        return window.getCart();
      }

      return currentCartData;
    }

    if (currentAttribute === groupTerm) {
      return currentCartData;
    }

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          utm_term: groupTerm
        }
      })
    });
    if (!response.ok) {
      console.error('Failed to update cart attributes:', response.status);
    }

    return window.getCart();
  }

  getActiveCustomerGroupKey() {
    const customerGroupTerm = this.normalizeCustomerGroupTerm(this.getCustomerGroupTerm()).toLowerCase();
    if (!customerGroupTerm) return '';

    const groupATerm = this.getCustomerGroupTermConfig('groupA').toLowerCase();
    const groupBTerm = this.getCustomerGroupTermConfig('groupB').toLowerCase();

    if (groupATerm && groupATerm === groupBTerm && this.customerGroupTermCollisionWarning !== groupATerm) {
      console.warn(
        'Customer group A and group B are configured with the same utm_term. Group B is unreachable.',
        { term: groupATerm }
      );
      this.customerGroupTermCollisionWarning = groupATerm;
    }

    if (customerGroupTerm === groupATerm) return 'groupA';
    if (customerGroupTerm === groupBTerm) return 'groupB';
    return '';
  }

  getCustomerGroupClaimGroupKey(item) {
    if (!item || !item.properties || item.properties._source !== 'cart-claim') {
      return '';
    }

    const storedGroupKey = item.properties._customer_group_key;
    if (storedGroupKey === 'groupA' || storedGroupKey === 'groupB') {
      return storedGroupKey;
    }

    // Infer the group for claims created before the group key property existed
    // when the configured gift products are distinct.
    const shippingSettings = window.freeShipping?.shipping?.[0];
    const groupAProductId = shippingSettings?.newCustomerGroupA?.sellingGiftProductId;
    const groupBProductId = shippingSettings?.newCustomerGroupB?.sellingGiftProductId;
    const matchesGroupA = groupAProductId && String(item.product_id) === String(groupAProductId);
    const matchesGroupB = groupBProductId && String(item.product_id) === String(groupBProductId);

    if (matchesGroupA && !matchesGroupB) return 'groupA';
    if (matchesGroupB && !matchesGroupA) return 'groupB';
    return '';
  }

  isCustomerGroupClaimForGroup(item, groupKey, productId = '') {
    if (!item || !item.properties || item.properties._source !== 'cart-claim') {
      return false;
    }

    const storedGroupKey = this.getCustomerGroupClaimGroupKey(item);
    if (storedGroupKey) {
      return storedGroupKey === groupKey;
    }

    return Boolean(productId && String(item.product_id) === String(productId));
  }

  isNewCustomerGroupB() {
    return this.getActiveCustomerGroupKey() === 'groupB';
  }

  buildProgressContext(cartData) {
    const exchangeRate = parseFloat(window.Shopify.currency.rate);
    const promotion1 = window.promotionSettings.gwp[0];
    const promotion2 = window.promotionSettings.gwp[1];
    const promotion3 = window.promotionSettings.gwp[2];
    const freeShipping = window.freeShipping.shipping[0];
    const protectionAdj = getProtectionCartAdjustments(cartData);
    let cartTotal = cartData.total_price - protectionAdj.protectionCents;
    let cartTotalGift = cartData.total_price - protectionAdj.protectionCents;
    let itemCounts = Math.max(0, cartData.item_count - protectionAdj.protectionQty);
    let regularItemCounts = 0;
    const excludeSellingPlanNames = window.pmoBuyXgetYSettings.excludeSellingPlanNames
      ? window.pmoBuyXgetYSettings.excludeSellingPlanNames.split(",")
      : [];

    // Customer group claim items should never count toward qualification thresholds.
    cartData.items.forEach((item) => {
      const itemProperties = item.properties || {};
      const isProtectionItem =
        window.protectionProductId != null &&
        window.protectionProductId !== '' &&
        item.product_id != null &&
        String(item.product_id) === String(window.protectionProductId);
      const isCustomerGroupClaim = itemProperties._source === 'cart-claim' || itemProperties._source === 'multiple-buy-x-get-y';

      if (!isProtectionItem && !isCustomerGroupClaim && !this.isGiftLikeCartItem(item)) {
        regularItemCounts += Number(item.quantity) || 0;
      }

      if (isCustomerGroupClaim) {
        cartTotal = Math.max(0, cartTotal - item.line_price);
        cartTotalGift = Math.max(0, cartTotalGift - item.line_price);
        itemCounts = Math.max(0, itemCounts - item.quantity);
      }
    });

    if (excludeSellingPlanNames.length > 0) {
      excludeSellingPlanNames.forEach((selling_item) => {
        cartData.items.forEach((item) => {
          if (item.selling_plan && item.selling_plan.name.includes(selling_item)) {
            const skipProtection =
              window.protectionProductId != null &&
              window.protectionProductId !== '' &&
              item.product_id != null &&
              String(item.product_id) === String(window.protectionProductId);
            if (!skipProtection) {
              cartTotalGift = cartTotalGift - item.line_price;
            }
          }
        });
      });
    }

    return {
      cartData,
      exchangeRate,
      promotion1,
      promotion1Price: promotion1.minimumCartAmount * 100,
      promotion1Indicator: freeShipping.gift1Indicator,
      promotion2Indicator: freeShipping.gift2Indicator,
      promotion3Indicator: freeShipping.gift3Indicator,
      promotion2,
      promotion3,
      promotion2Price: promotion2.minimumCartAmount * 100,
      promotion3Price: promotion3.minimumCartAmount * 100,
      freeShipping,
      freeShippingPrice: freeShipping.threshold * 100,
      freeShippingIsCustom: freeShipping.is_custom,
      freeClaimPrice: freeShipping.freeClaimThreshold * 100,
      cartTotal,
      cartTotalGift,
      itemCounts,
      regularItemCounts,
      giftInventory1: promotion1.giftInventory,
      minimumGiftQuantity1: promotion1.minimumGiftQuantity,
      giftInventory2: promotion2.giftInventory,
      giftInventory3: promotion3.giftInventory,
      minimumGiftQuantity2: promotion2.minimumGiftQuantity,
      minimumGiftQuantity3: promotion3.minimumGiftQuantity,
      enableCartGift: freeShipping.enableCartGift
    };
  }

  getNewCustomerGroupConfig(exchangeRate) {
    const freeShipping = window.freeShipping && window.freeShipping.shipping
      ? window.freeShipping.shipping[0]
      : null;
    const activeGroupKey = this.getActiveCustomerGroupKey();
    const groupConfig = freeShipping && activeGroupKey
      ? freeShipping[`newCustomer${activeGroupKey.charAt(0).toUpperCase()}${activeGroupKey.slice(1)}`]
      : null;
    const sellingCount = Number.parseFloat(groupConfig?.sellingCount);
    const hasValidThreshold = Number.isFinite(sellingCount) && sellingCount >= 0;

    return {
      key: activeGroupKey,
      enabled: Boolean(groupConfig?.enabled) && hasValidThreshold && Boolean(groupConfig?.sellingGiftProductId),
      thresholdLocal: hasValidThreshold ? sellingCount * exchangeRate * 100 : 0,
      sellingText: groupConfig?.sellingText || '',
      badgeLabel: groupConfig?.badgeLabel || groupConfig?.sellingGiftTitle || 'Free Gift',
      sellingGiftProductId: groupConfig?.sellingGiftProductId || null,
      sellingGiftVariantId: groupConfig?.sellingGiftVariantId || null,
      sellingGiftAvailable: Boolean(groupConfig?.sellingGiftAvailable),
      discountCode: groupConfig?.discountCode || ''
    };
  }

  getNewCustomerGroupBConfig(exchangeRate) {
    return this.getNewCustomerGroupConfig(exchangeRate);
  }

  buildNewCustomerGroupMessage(template, amountText, badgeLabel = 'Free Gift') {
    if (!template) {
      template = `Spend [amount_gift] for ${badgeLabel}!`;
    }

    const amountHtml = `<span class='cart-save-message__price'>${amountText}</span>`;

    if (template.includes('[amount_selling]')) {
      return template.replace('[amount_selling]', amountHtml);
    }

    if (template.includes('[amount_gift]')) {
      return template.replace('[amount_gift]', amountHtml);
    }

    return `${template} ${amountHtml}`;
  }

  buildNewCustomerGroupBMessage(template, amountText, badgeLabel = 'Free Gift') {
    return this.buildNewCustomerGroupMessage(template, amountText, badgeLabel);
  }

  updateGroupBClaimDisplay(progressContext, groupConfig = progressContext.customerGroupConfig) {
    const claimWrappers = document.querySelectorAll('[data-group-claim], [data-group-b-claim]');
    if (!claimWrappers.length) return;

    const resolvedGroupConfig = groupConfig || this.getNewCustomerGroupConfig(progressContext.exchangeRate);
    claimWrappers.forEach((claimWrapper) => {
      const groupKey = claimWrapper.getAttribute('data-group-claim') || 'groupB';
      const claimButton = claimWrapper.querySelector('[data-group-claim-btn], [data-group-b-claim-btn]');
      const claimProductId =
        resolvedGroupConfig.key === groupKey
          ? resolvedGroupConfig.sellingGiftProductId || claimButton?.getAttribute('data-product-id')
          : claimButton?.getAttribute('data-product-id');
      const alreadyClaimed = Boolean(
        claimProductId &&
        progressContext.cartData &&
        Array.isArray(progressContext.cartData.items) &&
        progressContext.cartData.items.some((item) =>
          item.properties &&
          this.isCustomerGroupClaimForGroup(item, groupKey, claimProductId)
        )
      );
      const qualifiesForClaim =
        resolvedGroupConfig.enabled &&
        resolvedGroupConfig.key === groupKey &&
        progressContext.regularItemCounts > 0 &&
        progressContext.cartTotal >= resolvedGroupConfig.thresholdLocal &&
        !alreadyClaimed;

      claimWrapper.classList.toggle('hidden', !qualifiesForClaim);
    });
  }

  updateEmptyCartGroupBMessage(progressContext, groupConfig = progressContext.customerGroupConfig) {
    const emptyMessages = document.querySelectorAll(
      '[data-customer-group-empty-message], [data-group-b-empty-message]'
    );
    if (!emptyMessages.length) return;

    const resolvedGroupConfig = groupConfig || this.getNewCustomerGroupConfig(progressContext.exchangeRate);
    emptyMessages.forEach((emptyMessage) => {
      const groupKey = emptyMessage.getAttribute('data-customer-group-empty-message') || 'groupB';
      const shouldShow =
        resolvedGroupConfig.enabled &&
        resolvedGroupConfig.key === groupKey &&
        progressContext.regularItemCounts === 0;
      emptyMessage.classList.toggle('hidden', !shouldShow);
    });
  }

  getGroupBClaimedItems(cartData, groupConfig = null) {
    const resolvedGroupConfig = groupConfig || this.getNewCustomerGroupConfig(parseFloat(window.Shopify.currency.rate));
    const claimWrapper =
      document.querySelector(`[data-group-claim="${resolvedGroupConfig.key}"]`) ||
      document.querySelector('[data-group-b-claim]');
    const claimProductId =
      resolvedGroupConfig.sellingGiftProductId ||
      claimWrapper
        ?.querySelector('[data-group-claim-btn], [data-group-b-claim-btn]')
        ?.getAttribute('data-product-id');

    if (!claimProductId || !cartData || !Array.isArray(cartData.items)) {
      return [];
    }

    return cartData.items.filter((item) =>
      this.isCustomerGroupClaimForGroup(item, resolvedGroupConfig.key, claimProductId)
    );
  }

  async reconcileGroupBClaim(progressContext, groupConfig = progressContext.customerGroupConfig) {
    const resolvedGroupConfig = groupConfig || this.getNewCustomerGroupConfig(progressContext.exchangeRate);
    const allClaimedItems = progressContext.cartData?.items?.filter((item) =>
      item.properties && item.properties._source === 'cart-claim'
    ) || [];
    const activeClaimedItems = this.getGroupBClaimedItems(progressContext.cartData, resolvedGroupConfig);
    const inactiveClaimedItems = allClaimedItems.filter((item) => {
      const claimGroupKey = this.getCustomerGroupClaimGroupKey(item);
      return claimGroupKey && claimGroupKey !== resolvedGroupConfig.key;
    });
    const stillQualifies =
      resolvedGroupConfig.enabled &&
      progressContext.regularItemCounts > 0 &&
      progressContext.cartTotal >= resolvedGroupConfig.thresholdLocal;
    const itemsToRemove = new Map();

    inactiveClaimedItems.forEach((item) => itemsToRemove.set(item.key, item));
    if (!stillQualifies) {
      activeClaimedItems.forEach((item) => itemsToRemove.set(item.key, item));
    }

    if (!itemsToRemove.size) {
      return false;
    }

    for (const item of itemsToRemove.values()) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
      if (!response.ok) {
        console.error('Failed to remove item from cart:', response.status);
      }
    }

    return true;
  }

  updateProgressBarDisplay(progressContext, groupConfig = progressContext.customerGroupConfig) {
    const {
      cartData,
      exchangeRate,
      promotion1,
      promotion1Price,
      promotion1Indicator,
      promotion2Indicator,
      promotion3Indicator,
      promotion2,
      promotion3,
      promotion2Price,
      promotion3Price,
      freeShipping,
      freeShippingPrice,
      freeShippingIsCustom,
      cartTotal,
      cartTotalGift,
      itemCounts,
      giftInventory1,
      minimumGiftQuantity1,
      giftInventory2,
      giftInventory3,
      minimumGiftQuantity2,
      minimumGiftQuantity3,
      enableCartGift
    } = progressContext;

    const cartMessage = document.querySelector('.cart-save-message--progress');
    const progressBarWrap = document.querySelector('.progress-bar-wrap');
    const progressBar = document.querySelector('.progress-bar');
    const indicator = document.querySelector('.indicator');

    if (!cartMessage || !progressBarWrap) {
      return;
    }

    const display = itemCounts > 0 ? 'block' : 'none';
    cartMessage.style.display = display;
    progressBarWrap.style.display = display;

    const formatAmount = (amount) => {
      const roundedAmount = Math.floor(amount / 100) * 100;
      return formatMoney(roundedAmount).replace(/\.\d+/, '');
    };

    const promotion1PriceLocal = (promotion1Price / 100) * exchangeRate * 100;
    const promotion2PriceLocal = (promotion2Price / 100) * exchangeRate * 100;
    let freeShippingPriceLocal = (freeShippingPrice / 100) * exchangeRate * 100;
    if (freeShippingIsCustom) {
      freeShippingPriceLocal = freeShippingPrice;
    }

    const freeShippingPriceFlag = !!freeShippingPrice || freeShippingPrice === 0;
    const resolvedGroupConfig = groupConfig || this.getNewCustomerGroupConfig(exchangeRate);
    this.updateGroupBClaimDisplay(progressContext, resolvedGroupConfig);
    this.updateEmptyCartGroupBMessage(progressContext, resolvedGroupConfig);

    if (progressBarWrap.classList.contains("static")) {
      return;
    }

    if (progressBar) {
      progressBar.style.display = display;
    }

    let shippingMessage = "";
    let giftMessage = "";
    let groupMessage = "";
    let eligibleForPromotion1 = false;
    let eligibleForPromotion2 = false;
    let shippingBarCalc = 0;

    if (resolvedGroupConfig.enabled && cartTotal < resolvedGroupConfig.thresholdLocal) {
      const remainingAmount = resolvedGroupConfig.thresholdLocal - cartTotal;
      groupMessage = this.buildNewCustomerGroupMessage(
        resolvedGroupConfig.sellingText,
        formatAmount(remainingAmount),
        resolvedGroupConfig.badgeLabel
      );
    }

    if (enableCartGift) {
      const cartGiftMinAmountLocal = freeShipping.cartGiftIsCustom
        ? (freeShipping.cartGiftMinimumAmountLocal * 100)
        : (freeShipping.cartGiftMinimumAmountLocal * 100) * exchangeRate;

      if (cartTotal < cartGiftMinAmountLocal) {
        const barRemainingAmount = cartGiftMinAmountLocal - cartTotal;
        giftMessage = freeShipping.cartGiftProgressInfo.replace(
          "[amount_gift]",
          `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
        );
      } else {
        giftMessage = freeShipping.cartGiftProgressInfoQualified || "You've got some free gifts!";
      }

      if (freeShippingPriceFlag) {
        if (cartTotal < freeShippingPriceLocal) {
          const barRemainingAmount = freeShippingPriceLocal - cartTotal;
          shippingMessage = freeShipping.freeShippingNotquali.replace(
            "[amount_shipping]",
            `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
          );
        } else {
          shippingMessage = freeShipping.freeShippingQuali;
        }
      }

      const activeThresholds = [];
      if (freeShippingPriceFlag && cartTotal < freeShippingPriceLocal) {
        activeThresholds.push(freeShippingPriceLocal);
      }
      if (cartTotal < cartGiftMinAmountLocal) {
        activeThresholds.push(cartGiftMinAmountLocal);
      }

      if (itemCounts <= 0) {
        if (indicator) {
          indicator.style.transform = 'scale(0, 1)';
        }
      } else {
        const targetThreshold = activeThresholds.length > 0 ? Math.min(...activeThresholds) : cartTotal;
        shippingBarCalc = targetThreshold === 0 ? 1 : parseFloat(cartTotal / targetThreshold);
        shippingBarCalc = Math.min(shippingBarCalc, 1);
        if (indicator) {
          indicator.style.transform = 'scale(' + shippingBarCalc + ', 1)';
        }
      }
    } else {
      if (promotion1.enable && promotion1Indicator == 'true') {
        if (cartTotalGift < promotion1PriceLocal && giftInventory1 > minimumGiftQuantity1) {
          eligibleForPromotion1 = true;
          const barRemainingAmount = promotion1PriceLocal - cartTotalGift;
          giftMessage = freeShipping.gift1Notquali.replace(
            "[amount_gift]",
            `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
          );
        }
      }

      if (promotion2.enable && promotion2Indicator == 'true' && cartTotalGift >= promotion1PriceLocal) {
        if (cartTotalGift < promotion2PriceLocal) {
          eligibleForPromotion2 = true;
          const barRemainingAmount = promotion2PriceLocal - cartTotalGift;
          giftMessage = freeShipping.gift2Notquali.replace(
            "[amount_gift]",
            `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
          );
        }
      }

      if (freeShippingPriceFlag) {
        if (cartTotal < freeShippingPriceLocal) {
          const barRemainingAmount = freeShippingPriceLocal - cartTotal;
          shippingMessage = freeShipping.freeShippingNotquali.replace(
            "[amount_shipping]",
            `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
          );
        } else {
          shippingMessage = freeShipping.freeShippingQuali;
        }
      }

      const activeThresholds = [];
      if (freeShippingPriceFlag && cartTotal < freeShippingPriceLocal) {
        activeThresholds.push(freeShippingPriceLocal);
      }
      if (eligibleForPromotion1) {
        activeThresholds.push(promotion1PriceLocal);
      }
      if (eligibleForPromotion2) {
        activeThresholds.push(promotion2PriceLocal);
      }

      if (itemCounts <= 0) {
        if (indicator) {
          indicator.style.transform = 'scale(0, 1)';
        }
      } else {
        const targetThreshold = activeThresholds.length > 0 ? Math.min(...activeThresholds) : cartTotal;
        shippingBarCalc = targetThreshold === 0 ? 1 : parseFloat(cartTotal / targetThreshold);
        shippingBarCalc = Math.min(shippingBarCalc, 1);
        if (indicator) {
          indicator.style.transform = 'scale(' + shippingBarCalc + ', 1)';
        }
      }

      if (cartTotalGift >= freeShippingPriceLocal) {
        if (eligibleForPromotion1) {
          const barRemainingAmount = promotion1PriceLocal - cartTotalGift;
          giftMessage = freeShipping.gift1Notquali.replace(
            "[amount_gift]",
            `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
          );
        } else if (!eligibleForPromotion1 && eligibleForPromotion2) {
          const barRemainingAmount = promotion2PriceLocal - cartTotalGift;
          giftMessage = freeShipping.gift2Notquali.replace(
            "[amount_gift]",
            `<span class='cart-save-message__price'>${formatAmount(barRemainingAmount)}</span>`
          );
        } else if (cartTotalGift >= promotion2PriceLocal && promotion2.enable && promotion2Indicator == 'true') {
          giftMessage = freeShipping.giftFs12Quali || "";
        } else if (cartTotalGift >= promotion1PriceLocal && !promotion2.enable && promotion1.enable && promotion1Indicator == 'true') {
          giftMessage = freeShipping.giftFs12Quali || "";
        } else {
          giftMessage = "";
        }
      }
    }

    let combinedMessage = "";
    if (groupMessage) {
      combinedMessage += `<span class="cart-save-message__group-b">${groupMessage}${shippingMessage || giftMessage ? ' &' : ''}</span>`;
    }
    if (shippingMessage) {
      combinedMessage += `${combinedMessage ? ' ' : ''}<span class="cart-save-message__shipping">${shippingMessage}</span>`;
    }
    if (giftMessage) {
      combinedMessage += `${combinedMessage ? ' ' : ''}<span class="cart-save-message__gift">${giftMessage}</span>`;
    }

    cartMessage.innerHTML = combinedMessage;

    const shippingBadgeDisplay = (cartTotal > 0 && cartTotal >= freeShippingPriceLocal) ? 'flex' : 'none';
    const shippingBadge = document.querySelector('.progress__badge.progress__badge--shipping');
    if (shippingBadge) {
      shippingBadge.style.display = shippingBadgeDisplay;
    }

    const groupBadge = document.querySelector('.progress__badge.progress__badge--group-b');
    if (groupBadge) {
      const groupBadgeLabel = groupBadge.querySelector('[data-customer-group-badge-label]');
      if (groupBadgeLabel && resolvedGroupConfig.badgeLabel) {
        groupBadgeLabel.textContent = resolvedGroupConfig.badgeLabel;
      }
      groupBadge.style.display =
        resolvedGroupConfig.enabled &&
        progressContext.regularItemCounts > 0 &&
        cartTotal >= resolvedGroupConfig.thresholdLocal
          ? 'flex'
          : 'none';
    }

    if (!enableCartGift) {
      const giftBadgeDisplay =
        (promotion1.enable && promotion1Indicator == 'true' && cartTotalGift > 0 && cartTotalGift > promotion1PriceLocal)
          ? 'flex'
          : 'none';
      const giftBadge = document.querySelector('.progress__badge.progress__badge--gift');
      if (giftBadge) {
        giftBadge.style.display = giftBadgeDisplay;
      }

      const gift2BadgeDisplay =
        (promotion2.enable && promotion2Indicator == 'true' && cartTotalGift > 0 && cartTotalGift > promotion2PriceLocal)
          ? 'flex'
          : 'none';
      const giftBadge2 = document.querySelector('.progress__badge.progress__badge--gift-2');
      if (giftBadge2) {
        giftBadge2.style.display = gift2BadgeDisplay;
      }
    } else {
      const cartJsonItems =
        cartData && cartData.cartJson && Array.isArray(cartData.cartJson.items)
          ? cartData.cartJson.items
          : (cartData.items || []);
      const hasCartGift = cartJsonItems.some(item => item.properties && item.properties._source === 'cart-gift');
      const giftBadgeDisplay = hasCartGift ? 'flex' : 'none';

      const giftBadge = document.querySelector('.progress__badge.progress__badge--gift');
      if (giftBadge) {
        giftBadge.style.display = giftBadgeDisplay;
      }
      const giftBadge2 = document.querySelector('.progress__badge.progress__badge--gift-2');
      if (giftBadge2) {
        giftBadge2.style.display = 'none';
      }
    }

  }

  async renderContents(fromElement = '', force,newVariantId,replaceItemKey) {
    if (this.isRendering && !force) return;
    this.forceRender = false;
    this.isRendering = true;

    var cartObj = this;
    var totalSavings = 0;

    try {
        // Show loading overlay
        const overlay = document.querySelector('.mini-cart-overlay');
        overlay.style.opacity = "1";
        overlay.style.pointerEvents = "auto";

        /** InsCoder WANG.J 2026-05-28 B + Await async cart form before render **/
        const cartFormReady = await this.ensureCartFormLoaded();
        if (!cartFormReady && !this.querySelector('.cart-form')) {
          throw new Error('Cart form lazy load failed before renderContents().');
        }
        /** InsCoder WANG.J 2026-05-28 E + Await async cart form before render **/

        // SpeedSense: single cart sync (1 read + merged writes + 1 re-read);
        // fall back to a plain read if promotion writes fail so rendering completes
        let snapshot;
        try {
          snapshot = await window.runCartSync();
        } catch (syncError) {
          console.error('Cart sync failed; rendering the latest cart state:', syncError);
          snapshot = await window.getCart();
        }
        await window.updateCartTotalUSD(snapshot);

        await (async function() {
            const response = snapshot;
                localStorage.setItem('cart_json', JSON.stringify(response));

                const formatAmount = formatMoneyWithoutTrailingZeros;
                const exchangeRate = parseFloat(window.Shopify.currency.rate);
                

                if(response) {
                    const reducer = (a, b) => a + b;
                    let cartData = response;

                    // Nosto re-generate cart tagging after add item to cart
                    if(cartData){
                        var line_items = '';
                        var restore_link = '<span class="restore_link">'+window.location.origin+'/cart/';
                        const item_length = cartData.items.length;
                        if(cartData.items.length > 0){
                            cartData.items.forEach((item,i) => {
                                line_items += `<div class="line_item"><span class="product_id">${item.product_id}</span><span class="sku_id">${item.sku}</span><span class="quantity">${item.quantity}</span><span class="name">${item.title}</span><span class="unit_price">${formatMoney(item.price)}</span><span class="price_currency_code">${cartData.currency}</span></div>`;
                                restore_link += item.variant_id+':'+item.quantity;
                                if((i+1) < item_length){
                                    restore_link += ',';
                                }
                            });
                            restore_link += '</span>';
                            line_items += restore_link;
                        } else {
                            line_items = '';
                        }

                        document.querySelectorAll('.nosto_cart').forEach(function(element){
                            element.innerHTML = line_items;
                        });


                      // update Recommendations

                      if(document.querySelector(".nosto_element.nosto_element__sidebar")){
                        fetch("/?section_id=cust-cart-notification")
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          document.querySelector(".nosto_element.nosto_element__sidebar").innerHTML = html.querySelector(".nosto_element.nosto_element__sidebar").innerHTML
                          cartObj.initRecommendations();
                        });
                      }
                    }

                    // Cache frequently accessed DOM elements
                    const elements = {
                        cartMessage: document.querySelector(".cart-save-message.cart-save-message--progress"),
                        emptyCartShipping: document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-shipping]"),
                        emptyCartGift: document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-gift]"),
                        emptyCartGift2: document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-gift-2]"),
                        emptyCartGift3: document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-gift-3]"),
                        cartCountBubble: document.querySelector('.cart-count-bubble--value'),
                        cartCountBubbleWithLabel: document.querySelector('.cart-count-bubble-with-label--value'),
                        cartItemCount: document.querySelector('[data-cart-item-count]'),
                        progressBar: document.querySelector('.progress-bar'),
                        progressBarWrap: document.querySelector('.progress-bar-wrap'),
                        cartNotificationDrawer: document.querySelector('.cart-notification__drawer'),
                        cartForm: document.querySelector('.cart-form'),
                        cartItemsEmpty: document.querySelector('.cart-items__empty'),
                        cartFooterMain: document.querySelector('.cart-notification__footer.footer__main'),
                        cartItems: document.getElementById('cart-items')
                    };

                    // Your existing variable declarations
                    let progressContext = cartObj.buildProgressContext(cartData);
                    const groupConfig = cartObj.getNewCustomerGroupConfig(progressContext.exchangeRate);
                    progressContext.customerGroupConfig = groupConfig;
                    const groupBClaimUpdated = await cartObj.reconcileGroupBClaim(progressContext, groupConfig);
                    if (groupBClaimUpdated) {
                      await cartObj.renderContents(fromElement, true, newVariantId, replaceItemKey);
                      return;
                    }
                    var barRemainingAmount = 0,
                    cartMessage = document.querySelector(".cart-save-message.cart-save-message--progress"),
                    emptyCartShipping = document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-shipping]"),
                    emptyCartGift = document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-gift]"),
                    emptyCartGift2 = document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-gift-2]"),
                    emptyCartGift3 = document.querySelector(".cart-items__empty .cart-save-message [data-empty-message-gift-3]"),
                    promotion1 = progressContext.promotion1,
                    promotion1Price = progressContext.promotion1Price,
                    promotion1Indicator = progressContext.promotion1Indicator,
                    promotion2Indicator = progressContext.promotion2Indicator,
                    promotion3Indicator = progressContext.promotion3Indicator,
                    promotion2 = progressContext.promotion2,
                    promotion3 = progressContext.promotion3,
                    promotion2Price = progressContext.promotion2Price,
                    promotion3Price = progressContext.promotion3Price,
                    freeShipping = progressContext.freeShipping,
                    freeShippingPrice = progressContext.freeShippingPrice,
                    freeShippingIsCustom = progressContext.freeShippingIsCustom,
                    freeClaimPrice = progressContext.freeClaimPrice,
                    cartTotal = progressContext.cartTotal,
                    cartTotalGift = progressContext.cartTotalGift,
                    itemCounts = progressContext.itemCounts,
                    giftInventory1 = progressContext.giftInventory1,
                    minimumGiftQuantity1 = progressContext.minimumGiftQuantity1,
                    giftInventory2 = progressContext.giftInventory2,
                    giftInventory3 = progressContext.giftInventory3,
                    minimumGiftQuantity2 = progressContext.minimumGiftQuantity2,
                    minimumGiftQuantity3 = progressContext.minimumGiftQuantity3;
                    const cartCountBubble = document.querySelector('.cart-count-bubble--value')
                    const cartCountBubbleWithLabel = document.querySelector('.cart-count-bubble-with-label--value')
                    const enableCartGift = progressContext.enableCartGift;

                    // Update header cart count bubble value
                    cartCountBubble.innerHTML = itemCounts
                    cartCountBubbleWithLabel.innerHTML = itemCounts > 1 ? itemCounts + ' items' : itemCounts + ' item'
                    document.querySelector('[data-cart-item-count]').innerHTML = itemCounts

                const $cartLargestThreshold = cartObj.cartLargestThreshold;

                let freeShippingPriceFlag = false;
                if(freeShippingPrice) {
                  freeShippingPriceFlag = true;
                } else {
                  if (freeShippingPrice === 0){
                    freeShippingPriceFlag = true;
                  }
                }

                  // Display logic for cart-save-message and progress bars
              const display = itemCounts > 0 ? 'block' : 'none';
              document.querySelector('.cart-save-message--progress').style.display = display;
              document.querySelector('.progress-bar-wrap').style.display = display;


              const formatAmount = formatMoneyWithoutTrailingZeros;

              // Convert promotion prices from USD cents to local currency cents
              const promotion1PriceLocal = (promotion1Price / 100) * exchangeRate * 100;
              const promotion2PriceLocal = (promotion2Price / 100) * exchangeRate * 100;
              const promotion3PriceLocal = (promotion3Price / 100) * exchangeRate * 100;
              let freeShippingPriceLocal = (freeShippingPrice / 100) *  exchangeRate * 100;
              if(freeShippingIsCustom){
                freeShippingPriceLocal = (freeShippingPrice / 100) *  1 * 100;
              }
              const freeClaimPriceLocal = (freeClaimPrice / 100) *  exchangeRate * 100;

              cartObj.updateProgressBarDisplay(progressContext, groupConfig);
              // .sort((a, b) => {
              //             // Check if either item is a GWP and prioritize it
              //             const isAGWP = a.product_type.toLowerCase() === "gwp";
              //             const isBGWP = b.product_type.toLowerCase() === "gwp";
              //             return isAGWP === isBGWP ? 0 : isAGWP ? -1 : 1;
              //           })

                // Append items
                if(itemCounts > 0) {
                  document.querySelector('.cart-notification__count').style.display = 'inline-block';
                  if(itemCounts == 1){
                    document.querySelector('.cart-notification__count .item-count__1').style.display = 'none';
                  } else {
                    document.querySelector('.cart-notification__count .item-count__1').style.display = 'inline-block';
                  }
                  if(document.querySelector('.nosto__heading')){
                    document.querySelector('.nosto__heading').innerHTML = 'Pairs Well With';
                  }
                  document.querySelector('.cart-notification__drawer').classList.remove('cart__empty');
                  document.querySelector('.cart-form').classList.remove('cart-form__empty');
                  document.querySelector('.cart-items__empty').style.display = "none";
                  document.querySelector('.cart-notification__footer.footer__main').classList.remove('hidden')
                  document.querySelector('.cart-notification__footer').classList.remove('hidden')
                  if(document.getElementById('cart-items').classList.contains('hidden')) document.getElementById('cart-items').classList.remove('hidden')
                  if(document.querySelector('.cart-gift__wrapper')){
                    if (enableCartGift) {
                      // Multi-GWP: conditional button disable
                      const cartGiftMinAmountLocal = freeShipping.cartGiftIsCustom
                        ? (freeShipping.cartGiftMinimumAmountLocal * 100)
                        : (freeShipping.cartGiftMinimumAmountLocal * 100) * exchangeRate;

                      document.querySelector('.cart-gift__wrapper').classList.remove('hidden');

                      const giftBtns = document.querySelectorAll('.cart-gift__card-btn');
                      if (cartTotal >= cartGiftMinAmountLocal) {
                        giftBtns.forEach(btn => btn.removeAttribute('disabled'));
                      } else {
                        giftBtns.forEach(btn => btn.setAttribute('disabled', 'disabled'));
                      }
                    } else {
                      document.querySelector('.cart-gift__wrapper').classList.remove('hidden');
                    }
                  }
                  // document.getElementById('cart-items').innerHTML = cartItemTemplate
                  const cart_items = document.getElementById('cart-items');

                  cart_items.querySelectorAll(".cart-item__block").forEach(temp => temp.classList.add("removed"))
                cartData.cartJson.items.map((item, index) => {
                  if (
                    window.protectionProductId != null &&
                    window.protectionProductId !== '' &&
                    item.product_id != null &&
                    String(item.product_id) === String(window.protectionProductId)
                  ) {
                    return;
                  }
                  let variants = [];
                  let colorVariants = false;
                  let hasVariantSelector = false;
                  let hasItemOption = false;

                  const cartNotification = document.querySelector("cart-notification");
                  item.options_with_values.forEach(option => {
                    if (cartNotification.mulVariantOptions.includes(option.name)) {
                      colorVariants = true;
                    }
                    if (option.name === 'Item' || option.name === 'Size' || option.name === 'Select Your Set') {
                      hasItemOption = false;
                    }
                  });

                  const cartItemsData = Array.isArray(cartData.items) ? cartData.items : [];
                  const cartItem = cartItemsData.find(cartItem => cartItem.key === item.key) ||
                    cartItemsData.find(cartItem => {
                      return String(cartItem.id) === String(item.id) &&
                        String(cartItem.variant_id) === String(item.variant_id);
                    });
                  const sellingPlanGroups = Array.isArray(cartItem?.selling_plan_groups)
                    ? cartItem.selling_plan_groups
                    : (cartData.selling_plan_groups_by_key?.[item.key] || []);
                  const itemImage = cartItem?.image || item.featured_image?.url || item.image;
                  if (cartItem) {
                    variants = cartItem.product_variants || [];
                    if (cartItem.product_variants?.length > 1) {
                      hasVariantSelector = true;
                    }
                  }

                  let removeButton;
                  let compareAtPriceValue = ''
                  if(cartItem?.compare_at_price > 0){
                    compareAtPriceValue = formatMoney(cartItem.compare_at_price)
                  }
                  const compareAtPrice = cartItemsData.filter(cartJsonItem => {
                    if(cartJsonItem.id == item.id) {
                  const compare_at_price = cartJsonItem.compare_at_price
                  if(compare_at_price != null) {
                    totalSavings = totalSavings + (compare_at_price - cartJsonItem.original_price) * cartJsonItem.quantity;
                    // compareAtPriceValue = formatMoney(compare_at_price)
                  } else {
                    // compareAtPriceValue = '';
                  }
                    }
                  })

                  var quantityBox = '', productPrice = 0, productTitle = "",
                  isFreeGift = (item.properties && item.properties.free_gift) ? item.properties.free_gift : false,
                  isCartClaim = (item.properties && item.properties._source === 'cart-claim'),
                  isCartGift = (item.properties && item.properties._source === 'cart-gift'),
                  isMultipleBuyXGetYGift = (item.properties && item.properties._source === 'multiple-buy-x-get-y');

                  const productType = (item.product_type || '').toLowerCase();
                  const isGwp = productType === 'gwp';
                  const isGiftLikeItem = isGwp || isFreeGift || isCartGift || isMultipleBuyXGetYGift;
                  const canEditQuantity = !isGiftLikeItem;

                  removeButton = isCartClaim ? `
                  <a href="#" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item-claim">REMOVE</a>
                ` : (!isFreeGift && !isMultipleBuyXGetYGift ? `
                  <a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item">REMOVE</a>
                ` : '');

                  if (canEditQuantity) {
                    quantityBox = `<div class="cart-item__quantity">
                      <div class="cart-item__quantity-wrapper">
                        <quantity-input class="quantity">
                          <button class="quantity__button no-js-hidden" name="minus" type="button">
                            <span class="visually-hidden">decrease ${ item.title }</span>
                            <svg class="Icon Icon--minus " role="presentation" viewBox="0 0 16 2">
                              <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                            </svg>
                          </button>
                          <input class="quantity__input"
                            type="number"
                            name="updates[]"
                            variant-id="${item.variant_id}"
                            value="${ item.quantity }"
                            min="0"
                            aria-label="${ item.title }"
                            id="Quantity-${ index + 1 }"
                            data-index="${ index + 1 }"
                            data-line-id="${ item.key }"
                          >
                          <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">increase ${ item.title }</span>
                            <svg class="Icon Icon--plus " role="presentation" viewBox="0 0 16 16">
                              <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                <path d="M8,1 L8,15"></path>
                                <path d="M1,8 L15,8"></path>
                              </g>
                            </svg>
                          </button>
                        </quantity-input>
                      </div>
                    </div>`;

                    productPrice = formatMoney(item.price);
                    if(item.discounts.length){
                      compareAtPriceValue = formatMoney(item.original_price);
                      productPrice = formatMoney(item.line_price/item.quantity);
                    }
                    if(compareAtPriceValue.includes('.00')){
                      compareAtPriceValue = compareAtPriceValue.replace('.00', '');
                    }

                    if(productPrice.includes('.00')){
                      productPrice = productPrice.replace('.00', '');
                    }

                    const variantOptions = item.variant_options.map(option => {
                      return '<p class="cart-item__property">' + option.split("__")[0] + '</p>';
                      }).join('');

                      if (productType === 'gwp' || productType === 'upsell') {
                        // For GWP items - no link
                        if (!variantOptions.toLowerCase().includes('title')) {
                          productTitle = `<span class="cart-item__name h4 break">${item.product_title}${variantOptions}</span>`;
                        } else {
                          productTitle = `<span class="cart-item__name h4 break">${item.product_title}</span>`;
                        }
                      } else {
                        // For non-GWP items - include link
                        if (!variantOptions.toLowerCase().includes('title')) {
                          productTitle = `<a href="${item.url}" class="cart-item__name h4 break">${item.product_title}${variantOptions}</a>`;
                        } else {
                          productTitle = `<a href="${item.url}" class="cart-item__name h4 break">${item.product_title}</a>`;
                        }
                      }

                  } else {
                    quantityBox = `<div class="CartItem__Actions">
                    <span>Qty: 1</span>
                  </div>`;
                    // format price if greater than 0 and the item is a free gift
                    if((isFreeGift || isCartClaim || isMultipleBuyXGetYGift) && item.price > 0){
                      productPrice = formatMoney(item.price);
                      if(productPrice.includes('.00')){
                        productPrice = productPrice.replace('.00', '');
                      }
                    }else{
                      productPrice = "Free";
                    }

                    const variantOptions = item.variant_options.map(option => {
                      return '<p class="cart-item__property">' + option.split("__")[0] + '</p>';
                      }).join('');

                      if (!variantOptions.toLowerCase().includes('title')) {
                        productTitle = '<span class="cart-item__name h4 break">' + item.product_title + variantOptions + '</span>';
                    } else {
                      productTitle = '<span class="cart-item__name h4 break">' + item.product_title + '</span>';
                    }

                  }
                  if(item.vendor == "Rise.ai") {
                    quantityBox = '<div class="CartItem__Actions"><span>Qty: '+item.quantity+'</span><a href="/cart/change?quantity=0&amp;id='+item.key+'" class="CartItem__Remove link--text block text-sm mt-2" data-quantity="0" data-line-id="'+item.key+'" data-item-id="'+item.id+'"data-action="remove-item">Remove</a></div>';
                  }

                  const item_block = cart_items.querySelector(".cart-item__block[data-line-item-key='" + item.key+"']");
                  const rechargeEnable = cartNotification.dataset.rechargeEnable ? true: false;
                  const block_html =  `
                    <div class="cart-item" data-variant-id="${item.variant_id}">
                      <div class="cart-item__media">
                        <img class="cart-item__image trynow_item_image"
                          src="${ itemImage }"
                          alt="${ item.variant_title || item.product_title }"
                          loading="lazy"
                          width="240"
                          height="240"
                        >
                      </div>
                      <div class="cart-item__right">
                        <div class="cart-item__details">
                          ${ productTitle }
                          ${ item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${ item.selling_plan_allocation.selling_plan.name }</p>` : '' }
                          ${ quantityBox }
                        </div>
                      </div>

                      <div class="cart-item__options">
                        <div class="cart-item__price js-is-this">
                          <span class="cart-item__price-compare">${ productPrice }</span>
                          ${ compareAtPriceValue ? `<span class="cart-item__price-original">${ compareAtPriceValue }</span>` : '' }
                        </div>

                        ${ (item.product_type.toLowerCase() != "gwp" || isCartClaim) ? `
                          <div class="cart-item__update">
                        ${hasVariantSelector ? `<a href="#" class="edit-variant link--text" data-item-key="${item.key}">EDIT</a>` : '' }
                        ${ removeButton }
                          </div>
                        ` : '' }
                      </div>
                    </div>
                    ${(rechargeEnable&&(item.product_id != 4516431593533)) ? `<cart-subscription class="cart-item__inner-subscription hidden" data-recharge-subscription-text="${ cartNotification.dataset.rechargeSubscriptionText }" data-recharge-subscription-save-label="${ cartNotification.dataset.rechargeSubscriptionSaveLabel }" data-product-id="${ item.product_id }" data-selling-plan-id="${ item.selling_plan_allocation?item.selling_plan_allocation.selling_plan.id:'' }" data-selling-plan-groups="${ encodeURIComponent(JSON.stringify(sellingPlanGroups)) }">
                      <div class="cart-item__inner-subscription-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M9.24763 6.43702C9.17303 6.22724 9.03543 6.04564 8.85365 5.91707C8.67187 5.78851 8.45481 5.71926 8.23216 5.7188H7.39855C7.16072 5.71756 6.93089 5.80454 6.75348 5.96294C6.57608 6.12133 6.4637 6.33988 6.4381 6.57632C6.41249 6.81276 6.47546 7.0503 6.61484 7.24301C6.75422 7.43571 6.96011 7.56988 7.19268 7.61958L8.46202 7.89653C8.72157 7.95335 8.95097 8.10408 9.10614 8.31976C9.26131 8.53544 9.3313 8.80085 9.30268 9.065C9.27405 9.32915 9.14883 9.5734 8.95106 9.75083C8.75329 9.92826 8.49693 10.0264 8.23123 10.0263H7.51394C7.04498 10.0263 6.64617 9.72715 6.49847 9.30896M7.87305 5.7188V4.64148M7.87305 11.1036V10.0272M3.38281 13.9995V11.6916H5.69071" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.8971 6.89585C14.1422 8.20231 13.9465 9.55318 13.3409 10.7364C12.7352 11.9196 11.7537 12.8683 10.5506 13.4334C9.34744 13.9985 7.99071 14.1482 6.69333 13.8588C5.39596 13.5695 4.23137 12.8575 3.38237 11.8347M2.10288 9.10404C1.8578 7.79758 2.05347 6.44672 2.65916 5.26349C3.26486 4.08025 4.24629 3.13163 5.44943 2.5665C6.65257 2.00137 8.0093 1.85174 9.30668 2.14108C10.6041 2.43042 11.7686 3.14236 12.6176 4.16515" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.6175 2.00122V4.30911H10.3096" stroke="black" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                      </div>
                      <div class="cart-item__inner-subscription-text">
                          <div class="cart-item__inner-subscription-default">
                          </div>
                          <div class="cart-item__inner-subscription-select" >
                              <select class="cart-item__inner-subscription-select-sel">
                                  <optgroup label="Pay Full Price">
                                  <option value="">One-time only</option>
                                  </optgroup>

                              </select>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M8 10L12.2 14.2L16.4 10" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                          </div>
                      </div>
                  </cart-subscription>`: ''}
                    `
                    // colorVariants && hasItemOption == false &&
                  const script_html = `<div class="cart-item__variant-picker one-time">
                    <div class="variant-picker__content">
                      <div class="cart-notification__header">
                        <h2 class="cart-notification__heading caption-large text-body">Select Shade</h2>
                        <button type="button" class="variant-picker__close link link--text focus-inset">
                          <img src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/close.svg?v=1725933626" width="24" height="24">
                        </button>
                      </div>
                     <div class="cart-item" data-variant-id="${item.variant_id}">
                        <div class="cart-item__media">
                          <img class="cart-item__image"
                            src="${ itemImage }"
                            alt="${ item.variant_title || item.product_title }"
                            loading="lazy"
                            width="240"
                            height="240"
                          >
                        </div>
                        <div class="cart-item__right">
                          <div class="cart-item__details">
                            ${ productTitle }
                            ${ item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${ item.selling_plan_allocation.selling_plan.name }</p>` : '' }
                            ${ quantityBox }
                          </div>
                        </div>

                        <div class="cart-item__options">
                          <div class="cart-item__price">
                            <span class="cart-item__price-compare">${ productPrice }</span>
                            ${ compareAtPriceValue ? `<span class="cart-item__price-original">${ compareAtPriceValue }</span>` : '' }
                          </div>

                          ${ item.product_type.toLowerCase() != "gwp" ? `
                            <div class="cart-item__update">
                          ${hasVariantSelector ? `<a href="#" class="edit-variant link--text" data-item-key="${item.key}">EDIT</a>` : '' }
                              <a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item">REMOVE</a>
                            </div>
                          ` : '' }
                       </div>
                      </div>
                      <variant-radios class="no-js-hidden swatch_round" data-section data-url="/products/${item.handle}">
                            <div class="cart-item__active-variant">
                              <div class="active-variant__content">
                              ${(() => {
                                const matchedVariant = variants.find(variant => variant.id === item.id);
                                const swatchColor = matchedVariant ? matchedVariant.metafields.swatch_color : 'transparent';
                                const variantTitle = matchedVariant ? matchedVariant.name : 'Unknown Variant';

                                const swatchFile = matchedVariant ? matchedVariant.metafields.swatch_img: '';
                                if(swatchFile && (!swatchColor || swatchColor == 'transparent')){
                                   return `
                                    <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;">
                                      <img src="${ swatchFile }" loading="lazy" width="58" height="58">
                                    </span>
                                    <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                                  `;
                                }
                                return `
                                  <span class="active-variant__swatch" style="background-color: ${swatchColor}; display: inline-block;"></span>
                                  <span class="active-variant__title" style="opacity: 1;">${ variantTitle }</span>
                                `;
                              })()}
                              </div>
                              <img class="active-variant__close inverted" src="https://cdn.shopify.com/s/files/1/0007/9858/8989/files/arrow-down.svg?v=1725933654" height="24" width="24">
                            </div>
                          <div class="active-variant__drawer">

                          </div>
                          <script-element type="application/json">
                            ${JSON.stringify(variants)}
                          </script-element>
                      </variant-radios>
                      <div class="cart-notification__footer footer__static ">
                        <div class="cart_drawer_formBox">
                        ${(() => {
                                const matchedVariant = variants.find(variant => variant.id === item.id);
                                const safeIndex = Math.max(index - 1, 0);
                                return `
                          <button type="button" class="button btn variant-update__btn" data-variant-id="${item.id}" data-line-item-key="${item.key}" data-line-item-index="${ safeIndex }" data-quantity="${ item.quantity }">
                            <span class="btn__text button--full-width">Update</span>
                          </button>
                                `;
                              })()}

                        </div>
                      </div>
                    </div>
                  </div>`
                  if(!item_block){
                    const fragment = document.createDocumentFragment();
                    const block = document.createElement('div');
                    block.className = 'cart-item__block' + (isCartGift ? ' cart-item--cart-gift' : '');
                    block.setAttribute('data-variant-id', item.variant_id);
                    block.setAttribute('data-line-item-key', item.key);
                    block.innerHTML = block_html
                    const script = document.createElement('script');
                    script.type = 'application/x-template';
                    script.setAttribute('data-line-item-variant-picker', item.key || '');
                    script.textContent = script_html;
                    fragment.appendChild(block);
                    fragment.appendChild(script);
                    if(newVariantId && replaceItemKey && newVariantId == item.variant_id){
                      const oldItem = cart_items.querySelector(".cart-item__block[data-line-item-key='" + replaceItemKey+"']")
                      if (oldItem) {
                        cart_items.insertBefore(fragment, oldItem);
                      }
                    }else{
                      cart_items.append(fragment)
                    }
                  }else{
                    item_block.classList.remove("removed");
                    item_block.setAttribute('data-variant-id', item.variant_id);
                    item_block.setAttribute('data-line-item-key', item.key);
                    const itemImageElement = item_block.querySelector('.cart-item__image');
                    if (itemImageElement) {
                      itemImageElement.src = itemImage;
                      itemImageElement.alt = item.variant_title || item.product_title;
                    }
                    item_block.querySelector(".cart-item__details").innerHTML = `${ productTitle } ${ item.selling_plan_allocation ? `<p class="cart-item__selling-plan">${ item.selling_plan_allocation.selling_plan.name }</p>` : '' } ${ quantityBox }`
                    item_block.querySelector(".cart-item__options").innerHTML = `<div class="cart-item__price">
                            <span class="cart-item__price-compare">${ productPrice }</span>
                            ${ compareAtPriceValue ? `<span class="cart-item__price-original">${ compareAtPriceValue }</span>` : '' }
                          </div>

                          ${ item.product_type.toLowerCase() != "gwp" ? `
                            <div class="cart-item__update">
                          ${hasVariantSelector ? `<a href="#" class="edit-variant link--text" data-item-key="${item.key}">EDIT</a>` : '' }
                              <a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove link--text" data-quantity="0" data-line-id="${item.key}" data-item-id="${item.id}" data-action="remove-item">REMOVE</a>
                            </div>
                          ` : '' }`
                  }
                })

                  cart_items.querySelectorAll(".cart-item__block.removed").forEach(temp => temp.remove());
                  cart_items.querySelectorAll('cart-subscription').forEach((subscription) => {
                    if (typeof subscription.initialize === 'function') {
                      subscription.initialize();
                    }
                  });

                  // Update Sub Total, Savings, & Cart Item Count
                  document.querySelectorAll('.button__price').forEach(buttonPriceElement => {
                    if (!buttonPriceElement.classList.contains('nosto-price')) {
                      buttonPriceElement.innerHTML = formatMoney(cartData.total_price);
                    }
                  });
                  if(document.querySelector('[data-order-rewards-points]')){
                    document.querySelector('[data-order-rewards-points]').innerHTML = window.cartTotalUSD;
                  }
                  document.querySelector('[data-cart-item-count]').innerHTML = itemCounts

                  const cartClaimWrapper = document.querySelector('.cart-claim__wrapper');
                  if(cartClaimWrapper){
                    const swiperWrapper = cartClaimWrapper.querySelector('.swiper-wrapper');
                    const slides = swiperWrapper.querySelectorAll('.swiper-slide');

                    // Calculate claimedCount
                    const claimLimit = window.claimLimit; // Get the claim limit from the global variable
                    const claimedCount = cartObj.slideElementsMap.size;
                    console.log(freeClaimPriceLocal,cartTotal)
                    // Check if there are slides and if the claimed count exceeds the claim limit
                    if(cartTotal > freeClaimPriceLocal){
                      if (slides.length > 0 && claimedCount < claimLimit) {
                        cartObj.initializeClaimVariants();
                        cartClaimWrapper.classList.remove('hidden');
                      } else {
                        cartClaimWrapper.classList.add('hidden');
                      }
                    }else{
                      cartClaimWrapper.classList.add('hidden');
                      for (const [key, value] of cartObj.slideElementsMap) {
                        const removeVariantEle = document.querySelector(".cart-item[data-variant-id='"+key+"']");
                        const removeBtn = removeVariantEle.querySelector(".CartItem__Remove");
                        await cartObj.handleRemoveCartClaim(removeBtn.dataset.lineId, key);
                        cartObj.forceRender = true;
                      }
                    }
                  }

                } else {
                  // Reinsert slides back into the slider before clearing the slideElementsMap
                  cartObj.slideElementsMap.forEach((value, key) => {
                    const slideElement = document.createElement('div');
                    slideElement.classList.add('swiper-slide');
                    slideElement.innerHTML = value.html;
                    cartObj.swiperCartClaim.appendSlide(slideElement);
                    cartObj.swiperCartClaim.update();

                  // Show navigation arrows if there are multiple unique slides
                  document.querySelector('.swiper-button-next').style.display = 'block';
                  document.querySelector('.swiper-button-prev').style.display = 'block';
                  });

                  // Clear the slideElementsMap
                  cartObj.slideElementsMap.clear();

                  if(document.querySelector('.nosto__heading')){
                    document.querySelector('.nosto__heading').innerHTML = 'Recommended Products';
                  }

                  document.querySelector('.cart-notification__count').style.display = 'none';
                  if(document.querySelector('.cart-claim__wrapper')){
                    document.querySelector('.cart-claim__wrapper').classList.add('hidden')
                  }
                  if(document.querySelector('.cart-gift__wrapper')){
                    document.querySelector('.cart-gift__wrapper').classList.add('hidden');
                  }

                  localStorage.removeItem('totalSavingsValue')
                  document.querySelector('.progress-bar-wrap').style.display = 'none';
                  document.querySelector('.cart-notification__drawer').classList.add('cart__empty');
                  document.querySelector('.cart-form').classList.add('cart-form__empty');

                  if(emptyCartShipping) {
                    // Convert free shipping threshold to local currency
                    const freeShippingLocal = (freeShippingPrice / 100) * exchangeRate * 100;

                    if (cartTotal >= freeShippingLocal) {
                      emptyCartShipping.innerHTML = freeShipping.freeShippingQuali;
                    } else {
                      emptyCartShipping.innerHTML = freeShipping.freeShippingNotquali.replace(
                        "[amount_shipping]",
                        `<span class='cart-save-message__price'>${formatAmount(freeShippingLocal)}</span>`
                      );
                    }
                  }

                  if(emptyCartGift) {
                    if (enableCartGift) {
                      // Multi-GWP Empty cart message
                      const cartGiftMinAmountLocal = freeShipping.cartGiftIsCustom
                        ? (freeShipping.cartGiftMinimumAmountLocal * 100)
                        : (freeShipping.cartGiftMinimumAmountLocal * 100) * exchangeRate;

                      const emptyMessage = freeShipping.cartGiftProgressInfo.replace(
                        "[amount_gift]",
                        `<span class='cart-save-message__price'>${formatAmount(cartGiftMinAmountLocal)}</span>`
                      );
                      emptyCartGift.innerHTML = emptyMessage;
                      if (emptyCartGift2) emptyCartGift2.innerHTML = "";
                    } else {
                      if (cartTotal >= promotion3PriceLocal && promotion3.enable && promotion3Indicator == 'true') {
                        emptyCartGift.innerHTML = freeShipping.giftFs123Quali || freeShipping.giftFs12Quali;
                      } else if (cartTotal >= promotion2PriceLocal && promotion2.enable && promotion2Indicator == 'true') {
                          // Both gifts qualify
                          emptyCartGift.innerHTML = freeShipping.giftFs12Quali;
                      } else {
                          // For empty cart, show both messages with their respective full amounts
                          const gift1Message = freeShipping.gift1Notquali.replace(
                              "[amount_gift]",
                              `<span class='cart-save-message__price'>${formatAmount(promotion1PriceLocal)}</span>`
                          );
                          const gift2Message = freeShipping.gift2Notquali.replace(
                              "[amount_gift]",
                              `<span class='cart-save-message__price'>${formatAmount(promotion2PriceLocal)}</span>`
                          );
                          const gift3Message = (freeShipping.gift3Notquali || '').replace(
                              "[amount_gift]",
                              `<span class='cart-save-message__price'>${formatAmount(promotion3PriceLocal)}</span>`
                          );

                          if (emptyCartGift2) {
                              emptyCartGift2.innerHTML = `${gift2Message}`;
                          }
                          if (emptyCartGift3) {
                              emptyCartGift3.innerHTML = `${gift3Message}`;
                          }
                          if(emptyCartGift){
                          emptyCartGift.innerHTML = `${gift1Message}`;
                        }
                      }
                    }
                  }
                  document.querySelector('.cart-items__empty').style.display = "flex";
                  document.querySelector('.cart-notification__footer.footer__main').classList.add('hidden')
                  if(!document.getElementById('cart-items').classList.contains('hidden')) document.getElementById('cart-items').classList.add('hidden')
                  document.getElementById('cart-items').innerHTML = ""
                }
                  document.querySelector('.mini-cart-overlay').style.opacity = "0";
                  document.querySelector('.mini-cart-overlay').style.pointerEvents = "none";

                  let variantRadios = document.querySelectorAll('variant-radios');
                    variantRadios.forEach(function(variantRadio) {
                      variantRadio.initializeVariantPicker();
                    });


                    const variantPickers = document.querySelectorAll('.cart-item__variant-picker');
                    variantPickers.forEach(variantPicker => {
                      if(variantPicker.classList.contains('one-time')){
                        variantPicker.remove();
                      }else{
                        if (variantPicker.classList.contains('variant-picker__expanded')) {
                          variantPicker.classList.remove('variant-picker__expanded');
                          const activeVariantDrawer = variantPicker.querySelector(".active-variant__drawer");
                          if (activeVariantDrawer) {
                            activeVariantDrawer.innerHTML = "";
                          }
                        }
                      }
                    });


                    cartObj.quantityInput();
                    cartObj.initializeRemoveListeners();
                    cartObj.initCartGift();
                    cartObj.initializeGroupBClaimButtons();

                    if(fromElement == 'FROM_ADD_TO_CART') {
                        cartObj.open(cartObj.forceRender ? null : response);
                    }
                }
            })().catch(error => {
                console.error('Error rendering cart contents:', error);
        });


    } catch (error) {
        console.error('Error in renderContents:', error);
    } finally {
      console.log("addToCartSuccess")
      document.dispatchEvent(new CustomEvent('addToCartSuccess'));
      setTimeout(() => {
        if(this.forceRender){
          this.renderContents("",true);
        }else{
          this.isRendering = false;
          const overlay = document.querySelector('.mini-cart-overlay');
          overlay.style.opacity = "0";
          overlay.style.pointerEvents = "none";
        }
    }, 100); // Small delay to ensure all operations are complete
    }
  }

  // Inactive: code moved into Nosto App - Inscoder AC 2024-08-14
  addToCartNosto(e) {
    var cartObj = this;
    var nostoVariantID = e.target.attributes["data-variant-id"].value;
    document.querySelector('.mini-cart-overlay').style.opacity = "1";
    document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

    fetch('/cart/add.js', {
        body: JSON.stringify({ id: nostoVariantID, quantity: 1 }),
        credentials: "same-origin",
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
    })
    .then((response) => response.json())
    .then((response) => {
      cartObj.renderContents();
    });
  }

  quantityInput() {
    const reducer = (a, b) => a + b;
    // Add change event in each qty input to update item
    var cartObj = this;
    document.querySelectorAll('.cart-notification__body .quantity__input').forEach(qtyInput => {
      qtyInput.addEventListener('change', async function() {
        document.querySelector('.mini-cart-overlay').style.opacity = "1";
        document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

        const thisValue = this.value
        const thisVariantID = this.getAttribute('variant-id')
        const thisLine = this.getAttribute('data-index')
        const thisLineId = this.getAttribute('data-line-id') || this.closest('.cart-item__block')?.getAttribute('data-line-item-key')
        const updateData = { line: thisLine, quantity: thisValue }

          if(thisValue == 0) {
            const lineItemElement = document.querySelector(`[data-variant-id="${thisVariantID}"]`)
            if (lineItemElement) lineItemElement.style.display = 'none'
          }

          if(thisValue > 9) {
            this.classList.add('max-quantity-reach')
            document.querySelector('.mini-cart-overlay').style.opacity = "0";
            document.querySelector('.mini-cart-overlay').style.pointerEvents = "none";

            return
          }
          else {
            this.classList.remove('max-quantity-reach')
          }
          if(thisValue <= 9) {
            if(thisValue == 0 && thisLineId) {
              try {
                const removeUpdates = await cartObj.buildRemoveUpdatesWithDependentGifts(thisLineId, thisVariantID);
                await window.removeGiftProduct(removeUpdates);
                cartObj.renderContents();
              } catch (error) {
                console.log('Request failed', error);
              }

              return;
            }

            fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(updateData)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Assuming the server responds with JSON
            })
            .then(data => {
                cartObj.renderContents(); // Render contents after processing the response
            })
            .catch(error => {
                console.log('Request failed', error);
            });
        }
      })
    })
  }

  isGiftLikeCartItem(item) {
    const productType = (item.product_type || '').toLowerCase();
    const itemProperties = item.properties || {};

    return productType === 'gwp' ||
      item.price === 0 ||
      item.final_price === 0 ||
      itemProperties.free_gift ||
      itemProperties._source === 'cart-gift' ||
      itemProperties._source === 'multiple-buy-x-get-y';
  }

  async buildRemoveUpdatesWithDependentGifts(itemKey, itemId) {
    const removeUpdates = {};
    const removedItemKey = itemKey || itemId;

    removeUpdates[removedItemKey] = 0;

    const cartData = await window.getCart();
    const removedItem = cartData.items.find(cartItem =>
      (itemKey && cartItem.key === itemKey) ||
      (itemId && cartItem.id.toString() === itemId.toString())
    );

    if (!removedItem || this.isGiftLikeCartItem(removedItem)) {
      return removeUpdates;
    }

    const nonGiftItemsAfterRemove = cartData.items.filter(cartItem =>
      cartItem.key !== removedItem.key && !this.isGiftLikeCartItem(cartItem)
    );

    if (nonGiftItemsAfterRemove.length > 0) {
      return removeUpdates;
    }

    cartData.items
      .filter(cartItem => this.isGiftLikeCartItem(cartItem))
      .forEach(giftItem => {
        removeUpdates[giftItem.key || giftItem.id] = 0;
      });

    return removeUpdates;
  }

  async removeProduct(item) {
    item.preventDefault();
    item.stopPropagation(); // Add this line to prevent event bubbling

    if (this.isRendering) return; // Add this to prevent multiple executions

    const removeButton = item.currentTarget || item.target;
    const itemId = removeButton.getAttribute("data-item-id");
    const itemKey = removeButton.getAttribute("data-line-id");
    if (!itemId && !itemKey) return; // Add validation

    document.querySelector('.mini-cart-overlay').style.opacity = "1";
    document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

    try {
        const removeUpdates = await this.buildRemoveUpdatesWithDependentGifts(itemKey, itemId);
        await window.removeGiftProduct(removeUpdates);
        await this.renderContents();
    } catch (error) {
        console.error('Error removing product:', error);
    }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('#cart-icon-bubble') && !target.closest('[data-action="nosto-addtocart"]')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setScreenHeight() {
    // ios fix for 100vh
    var screenHeight = window.innerHeight;
    document.documentElement.style.setProperty("--screen-height", screenHeight + "px");
  }

  initializeRemoveListeners() {
    // Regular remove items
    this.removeItems = this.notification.querySelectorAll("[data-action='remove-item']")
    this.removeItems.forEach((removeButton) => {
      removeButton.addEventListener('click', this.removeProduct.bind(this))
    })

    // Claim items
    this.notification.querySelectorAll("[data-action='remove-item-claim']").forEach((removeButton) => {
      removeButton.addEventListener('click', async (e) => {
        e.preventDefault();
        const itemKey = e.target.getAttribute('data-line-id');
        const itemId = e.target.getAttribute('data-item-id');

        document.querySelector('.mini-cart-overlay').style.opacity = "1";
        document.querySelector('.mini-cart-overlay').style.pointerEvents = "auto";

        await this.handleRemoveCartClaim(itemKey, itemId);
        this.renderContents();
      })
    })
  }
}

customElements.define('cart-notification', CartNotification);

class CartSubscription extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.initialize = this.initialize.bind(this);
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.selectElement = this.querySelector(".cart-item__inner-subscription-select-sel");

    if (!this.selectElement) {
      if (!this.initializationRetryScheduled && (this.initializationRetryCount || 0) < 1) {
        this.initializationRetryCount = (this.initializationRetryCount || 0) + 1;
        this.initializationRetryScheduled = true;
        const retry = () => {
          this.initializationRetryScheduled = false;
          this.initialize();
        };

        if (typeof queueMicrotask === 'function') {
          queueMicrotask(retry);
        } else {
          setTimeout(retry, 0);
        }
      }
      return;
    }

    this.initHTML();

    const selectElement = this.selectElement;

    if (this.subscriptionEventsBound) {
      return;
    }
    this.subscriptionEventsBound = true;

    this.addEventListener('click', (event) => {
      if (event.target !== selectElement) {
        this.classList.add("selected");
        if (!this.selectElement.value) {
          const firstNonEmpty = Array.from(this.selectElement.options).find(opt => opt.value.trim() !== '');
          if (firstNonEmpty) {
            firstNonEmpty.selected = true;
            this.selectElement.dispatchEvent(new Event('change'));
          }
        }
      }
    });
  }

  parseSellingPlanGroups() {
    const rawGroups = this.dataset.sellingPlanGroups;

    if (!rawGroups) {
      return [];
    }

    try {
      return JSON.parse(rawGroups);
    } catch (error) {
      try {
        return JSON.parse(decodeURIComponent(rawGroups));
      } catch (decodeError) {
        return [];
      }
    }
  }

  getSellingPlans() {
    return this.parseSellingPlanGroups().reduce((plans, group) => {
      if (group && Array.isArray(group.selling_plans)) {
        plans.push(...group.selling_plans);
      }

      return plans;
    }, []);
  }

  initHTML() {
    if (!this.selectElement) {
      return;
    }

    const rechargeSubscriptionText = (this.dataset.rechargeSubscriptionText || '').replace("[", "<a href='#'>").replace("]", "</a>");
    const rechargeSubscriptionSaveLabel = this.dataset.rechargeSubscriptionSaveLabel;
    const sellingPlanId = this.dataset.sellingPlanId;

    this.querySelector(".cart-item__inner-subscription-default").innerHTML = rechargeSubscriptionText;

    const existingPlanOptions = this.selectElement.querySelectorAll('optgroup[data-selling-plan-group] option');
    const plans = this.getSellingPlans().filter(plan => plan && plan.id != null);

    if (!plans.length && !existingPlanOptions.length) {
      return;
    }

    if (!existingPlanOptions.length) {
      const optionGroup = document.createElement('optgroup');
      optionGroup.label = rechargeSubscriptionSaveLabel || '';
      optionGroup.dataset.sellingPlanGroup = '';

      plans.forEach((plan) => {
        const option = document.createElement('option');
        option.value = String(plan.id);
        option.textContent = plan.name || 'Subscription';

        if (String(plan.id) === String(sellingPlanId)) {
          option.selected = true;
          this.classList.add("selected");
        }

        optionGroup.appendChild(option);
      });

      this.selectElement.appendChild(optionGroup);
    }

    const selectedOption = Array.from(this.selectElement.options).find((option) => {
      return option.value && String(option.value) === String(sellingPlanId);
    });
    if (selectedOption) {
      this.classList.add("selected");
    }

    this.classList.remove("hidden");
    if (this.boundSelectElement !== this.selectElement) {
      this.selectElement.addEventListener("change", this.handleChange);
      this.boundSelectElement = this.selectElement;
    }
  }

  async handleChange() {
    if (!this.selectElement) {
      return;
    }

    const select_plan_value = this.selectElement.value;
    const cart_item__block = this.closest(".cart-item__block");

    if (!cart_item__block || !cart_item__block.dataset.lineItemKey) {
      return;
    }

    const miniCartOverlay = document.querySelector('.mini-cart-overlay');
    const setOverlayLoading = (isLoading) => {
      if (!miniCartOverlay) {
        return;
      }

      miniCartOverlay.style.opacity = isLoading ? "1" : "0";
      miniCartOverlay.style.pointerEvents = isLoading ? "auto" : "none";
    };

    setOverlayLoading(true);

    const variantId = cart_item__block.dataset.variantId;
    const quantityInput = cart_item__block.querySelector("input.quantity__input");
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    const previousPlanValue = this.dataset.sellingPlanId || '';
    const lineItemKey = cart_item__block.dataset.lineItemKey;

    const removeData = {
      id: lineItemKey,
      quantity: 0
    };

    const requestCartJson = async (url, data, action) => {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      });

      let responseData = null;
      try {
        responseData = await response.json();
      } catch (parseError) {
        // Keep the request error useful even if the endpoint does not return JSON.
      }

      if (!response.ok) {
        const message = responseData && (responseData.description || responseData.message);
        throw new Error(message || `${action} request failed (${response.status})`);
      }

      return responseData;
    };

    const addData = {
      id: variantId,
      quantity
    };
    if (select_plan_value) addData.selling_plan = select_plan_value;

    let addDataResponse = null;
    let oldLineRemoved = false;

    try {
      // Add the replacement first so promotion validation never sees a cart
      // containing only free gifts between the two cart mutations.
      addDataResponse = await requestCartJson('/cart/add.js', addData, 'Add');
      await requestCartJson('/cart/change.js', removeData, 'Remove');
      oldLineRemoved = true;

      const cartObj = document.querySelector('cart-notification');
      if (!cartObj || typeof cartObj.renderContents !== 'function') {
        throw new Error('Cart notification is unavailable after updating the cart');
      }

      await cartObj.renderContents("", "", addDataResponse && addDataResponse.variant_id, lineItemKey);
    } catch (error) {
      // If adding succeeded but removing the old line did not, roll back the
      // replacement so a failed update does not leave duplicate paid items.
      if (addDataResponse && addDataResponse.key && !oldLineRemoved) {
        try {
          await requestCartJson('/cart/change.js', {
            id: addDataResponse.key,
            quantity: 0
          }, 'Rollback');
        } catch (rollbackError) {
          console.error('Rollback request failed', rollbackError);
        }
      }

      if (this.selectElement) {
        this.selectElement.value = previousPlanValue;
        if (previousPlanValue) {
          this.classList.add("selected");
        } else {
          this.classList.remove("selected");
        }
      }

      console.error('Request failed', error);
    } finally {
      setOverlayLoading(false);
    }
  }
}

customElements.define('cart-subscription', CartSubscription);


(function () {
  function injectStyleToProtectionModal(host) {
    if (!host || host.__styleObserverInited) return;
    host.__styleObserverInited = true;

    const startObserveShadow = () => {
      if (!host.shadowRoot) return false;

      const shadow = host.shadowRoot;

      const applyStyle = () => {
        const target = shadow.querySelector('#modal-dialog');

        if (target && !shadow.querySelector('#custom-style')) {
          const style = document.createElement('style');
          style.id = 'custom-style';
          style.textContent = `
            .complex-text-media-block > div {
              display: inline !important;
            }
            .complex-text-media-icon{
              margin-right: 5px;
            }
          `;
          shadow.appendChild(style);
        }
      };

      applyStyle();

      const shadowObserver = new MutationObserver(() => {
        applyStyle();
      });

      shadowObserver.observe(shadow, {
        childList: true,
        subtree: true
      });

      return true;
    };

    if (!startObserveShadow()) {
      const waitShadow = setInterval(() => {
        if (startObserveShadow()) {
          clearInterval(waitShadow);
        }
      }, 50);
    }
  }

  document.querySelectorAll('protection-modal').forEach(injectStyleToProtectionModal);

  const pageObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches && node.matches('protection-modal')) {
          injectStyleToProtectionModal(node);
        }

        if (node.querySelectorAll) {
          node.querySelectorAll('protection-modal').forEach(injectStyleToProtectionModal);
        }
      }
    }
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
